import React, { useState, useEffect, useCallback, useMemo, useRef, useDeferredValue } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Dialog,
    Button,
    TextField,
    Box,
    Typography,
    IconButton,
    Chip,
    useTheme,
    useMediaQuery,
    ButtonGroup,
    Tooltip,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Menu,

} from '@mui/material';


import {
    Close as CloseIcon,
    Add as AddIcon,
    DarkMode as DarkModeIcon,
    LightMode as LightModeIcon,
    TableChart as TableIcon,
    ViewModule as KanbanIcon,
    Save as SaveIcon,
    Warning as WarningIcon,
    Sync as SyncIcon,
    Archive as ArchiveIcon,
    Clear as ClearIcon,
    Engineering as EngineeringIcon,
    Search as SearchIcon,
    FilterList as FilterIcon,
    Timeline as TimelineIcon,
    Draw as DrawIcon,
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    Sort as SortIcon,
    ArrowUpward as ArrowUpIcon,
    ArrowDownward as ArrowDownIcon,
    Info as InfoIcon
} from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { setModal, setOverlayLayer } from '../../store/reducers/helpersReducer';
import { addTask, addTaskToQueue, updateTask, deleteTask, updateTaskId, removeFromQueue, clearQueue, fetchTasks } from '../../store/reducers/tasksReducer';
import { fetchUser, fetchUsersSettings, toggleDarkMode } from '../../store/reducers/stateReducer';
import { useAuth } from 'react-oidc-context';
import { $authHost } from '../../http';
import { getUsersByProject, getArchivedTasks } from '../../http/userApi';
import KanbanView from './TasksView/KanbanView';
import TableView from './TasksView/TableView';
import TableView2 from './TasksView/TableView2';
import { useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

import { createPortal } from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import TaskCreateAndSaveDialog from './TasksView/TaskCreateAndSaveDialog';
import { SpecsViewDialog } from './TasksView/SpecsViewDialog';
import { DeletedTasksDialog } from './TasksView/DeletedTasksDialog';
import { TaskDeleteConfirmDialog } from './TasksView/TaskDeleteConfirmDialog';
import TaskFilesDialog from './TasksView/TaskFilesDialog';
import KanbanView2 from './TasksView/KanbanView2';
import AuditHistoryDialog from './common/AuditHistoryDialog.jsx';
import { AdvancedFiltersComponent } from './common/AdvancedFilters.jsx';



export const PersonCustomIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px">
        <path fill={props.color} d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Z" />
    </svg>
);

export const CreatedDateIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill={props.color}>
        <path d="M680-80v-120H560v-80h120v-120h80v120h120v80H760v120h-80Zm-480-80q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h40v-80h80v80h240v-80h80v80h40q33 0 56.5 23.5T760-720v244q-20-3-40-3t-40 3v-84H200v320h280q0 20 3 40t11 40H200Zm0-480h480v-80H200v80Zm0 0v-80 80Z" />
    </svg>
);

export const EditedDateIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill={props.color}>
        <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v200h-80v-40H200v400h280v80H200Zm0-560h560v-80H200v80Zm0 0v-80 80ZM560-80v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
    </svg>
);

export const DeadlineDateIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill={props.color}>
        <path d="M200-640h560v-80H200v80Zm0 0v-80 80Zm0 560q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v227q-19-9-39-15t-41-9v-43H200v400h252q7 22 16.5 42T491-80H200Zm520 40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm67-105 28-28-75-75v-112h-40v128l87 87Z" />
    </svg>
);





// Статусы задач с их цветами и названиями
export const statusDefs = [
    { id: "new", title: "Новая задача", color: "#7cb342" },
    { id: "overdue", title: "Просрочено", color: "#8e2400" },
    { id: "progress", title: "В работе", color: "#1976d2" },
    { id: "review", title: "На проверке", color: "#9c27b0" },
    { id: "done", title: "Завершено", color: "#2e7d32" },
    { id: "paused", title: "Отложено", color: "#e65100" },
    { id: "cancelled", title: "Отменено", color: "#424242" }
];







// Генератор уникального ID
const generateId = () => crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random().toString(16).slice(2);

// Форматирование даты с временем в формате HH:MM dd.mm.yyyy
const formatDate = (date) => {
    if (!date) return 'Не указана';

    // Если date это строка, преобразуем в объект Date
    const dateObj = typeof date === 'string' ? new Date(date) : date;

    // Проверяем, что дата валидна
    if (isNaN(dateObj.getTime())) {
        return 'Неверная дата';
    }

    const hours = String(dateObj.getHours()).padStart(2, '0');
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    return `${hours}:${minutes} ${day}.${month}.${year}`;
};




// Компонент статуса с меню для изменения
const StatusChipWithMenu = ({ task, darkMode, onStatusChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        event.stopPropagation(); // Предотвращаем всплытие события
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusChange = (newStatus) => {
        // Проверяем разрешенные переходы
        const currentStatus = task.status;
        if (allowedTransitions[currentStatus]?.includes(newStatus) && newStatus !== currentStatus) {
            onStatusChange(newStatus);
        }
        handleClose();
    };

    const currentStatusDef = statusDefs.find(s => s.id === task.status);
    const availableStatuses = statusDefs.filter(status =>
        allowedTransitions[task.status]?.includes(status.id) && status.id !== task.status
    );

    return (
        <>
            <Chip
                label={currentStatusDef?.title || task.status}
                onClick={handleClick}
                sx={{
                    pr: '0.5rem',
                    backgroundColor: currentStatusDef?.color || '#666',
                    color: 'white',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    '& .MuiChip-label': {
                        pr: '0rem',
                    },
                    '&:hover': {
                        backgroundColor: currentStatusDef?.color || '#666',
                        opacity: 0.8,
                        transform: 'scale(1.05)',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                    },
                    '&::after': {
                        content: '" ▼"',
                        fontSize: '0.6rem',
                        marginLeft: '4px',
                        opacity: 0.7
                    }
                }}
            />
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'center', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                sx={{
                    '& .MuiPaper-root': {

                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                        borderRadius: '8px',
                        boxShadow: darkMode
                            ? '0 8px 32px rgba(0,0,0,0.4)'
                            : '0 8px 32px rgba(0,0,0,0.15)',
                        // minWidth: '200px'
                    },
                    '& .MuiList-root': {
                        py: 0
                    },
                    zIndex: 2000
                }}
            >
                {/* Заголовок меню */}
                <Box sx={{
                    px: 2,
                    py: 0,
                    borderBottom: darkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)',
                    bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)'
                }}>
                    <Typography variant="caption" sx={{
                        color: darkMode ? '#bbb' : '#666',
                        fontWeight: 600,
                        fontSize: '0.7rem'
                    }}>
                        Изменить статус
                    </Typography>
                </Box>

                {/* Текущий статус */}
                <MenuItem disabled sx={{ opacity: 1, py: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Chip
                            label={currentStatusDef?.title}
                            size="small"
                            sx={{
                                backgroundColor: currentStatusDef?.color,
                                color: 'white',
                                fontSize: '0.65rem',
                                fontWeight: 600,
                                mr: 1,
                                minWidth: '90px'
                            }}
                        />
                        {/* <Typography variant="caption" sx={{
                            color: darkMode ? '#4caf50' : '#2e7d32',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}>
                            (текущий)
                        </Typography> */}
                    </Box>
                </MenuItem>

                {/* Разделитель */}
                {availableStatuses.length > 0 && (
                    <Box sx={{
                        height: '1px',
                        bgcolor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                        mx: 1
                    }} />
                )}

                {/* Доступные статусы */}
                {availableStatuses.length > 0 ? (
                    availableStatuses.map((status) => (
                        <MenuItem
                            key={status.id}
                            onClick={() => handleStatusChange(status.id)}
                            sx={{
                                py: 1,
                                color: darkMode ? '#f5f7fa' : '#333',
                                '&:hover': {
                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                }
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Chip
                                    label={status.title}
                                    size="small"
                                    onClick={() => { }}
                                    sx={{
                                        backgroundColor: status.color,
                                        color: 'white',
                                        fontSize: '0.65rem',
                                        fontWeight: 600,
                                        mr: 1,
                                        minWidth: '90px'
                                    }}
                                />
                                {/* <Typography variant="caption" sx={{
                                    color: darkMode ? '#81c784' : '#4caf50',
                                    fontWeight: 500,
                                    fontSize: '0.7rem'
                                }}>
                                    ✓ доступен
                                </Typography> */}
                            </Box>
                        </MenuItem>
                    ))
                ) : (
                    <MenuItem disabled sx={{ py: 1 }}>
                        <Typography variant="caption" sx={{
                            color: darkMode ? '#666' : '#999',
                            fontStyle: 'italic',
                            fontSize: '0.7rem'
                        }}>
                            Нет доступных переходов
                        </Typography>
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

// Утилиты для работы с localStorage
const STORAGE_KEYS = {
    KANBAN_SETTINGS: 'kanban_settings'
};

const getStoredSettings = () => {
    try {
        const stored = localStorage.getItem(STORAGE_KEYS.KANBAN_SETTINGS);
        return stored ? JSON.parse(stored) : {};
    } catch {
        return {};
    }
};

const storeSettings = (settings) => {
    try {
        const current = getStoredSettings();
        const updated = { ...current, ...settings };
        localStorage.setItem(STORAGE_KEYS.KANBAN_SETTINGS, JSON.stringify(updated));
    } catch (error) {
        console.warn('Failed to save kanban settings:', error);
    }
};

// Разрешенные переходы между статусами
export const allowedTransitions = {
    new: ["progress", "paused", "cancelled"],
    overdue: [], // Колонка просрочено - только для отображения, перетаскивание из неё запрещено
    progress: ["review", "done", "paused", "cancelled"],
    review: ["progress", "done"],
    done: ["review", "progress"],
    paused: ["new", "progress", "cancelled"],
    cancelled: ["new", "progress", "paused"]
};

const TasksView = ({
    isModal = false,
    onClose = null,
    map = null,
    fromStartPage = false,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useDispatch();
    const auth = useAuth();
    const navigate = useNavigate();
    const modal = useSelector(state => state.helper.modal);
    const { tasks: reduxTasks, tasksQueue } = useSelector(state => state.tasks);
    const user = useSelector(state => state.state.user)
    const darkMode = useSelector(state => state.state.darkMode)
    const isOpen = modal?.modalType === 'tasks';

    // Получаем сохраненные настройки
    const storedSettings = getStoredSettings();

    // Состояние для свернутой колонки
    const [isOverdueCollapsed, setIsOverdueCollapsed] = useState(storedSettings.isOverdueCollapsed ?? false);


    // Состояние режима просмотра
    const [viewMode, setViewMode] = useState(storedSettings.viewMode ?? 'kanban'); // 'kanban' или 'table'

    // Добавляем глобальные стили для темного режима календаря
    useEffect(() => {
        const styleId = 'kanban-datetime-styles';
        let existingStyle = document.getElementById(styleId);

        if (existingStyle) {
            existingStyle.remove();
        }

        const darkModeStyles = `
            /* Темный режим для встроенного календаря браузера */
            .kanban-modal input[type="datetime-local"]::-webkit-calendar-picker-indicator {
                filter: ${darkMode ? 'invert(1) brightness(0.8) contrast(1.2)' : 'none'};
                cursor: pointer;
                opacity: ${darkMode ? 0.9 : 1};
            }
            
            .kanban-modal input[type="datetime-local"] {
                color-scheme: ${darkMode ? 'dark' : 'light'};
                background-color: ${darkMode ? '#2b2b2b !important' : '#fff !important'};
                color: ${darkMode ? '#f5f7fa !important' : '#333 !important'};
            }
            
            /* Попытка стилизации встроенного календаря */
            .kanban-modal input[type="datetime-local"]::-webkit-inner-spin-button,
            .kanban-modal input[type="datetime-local"]::-webkit-clear-button {
                filter: ${darkMode ? 'invert(1)' : 'none'};
            }
            
            /* Глобальные стили для всех элементов datetime */
            ${darkMode ? `
                html[data-kanban-dark="true"] input[type="datetime-local"] {
                    color-scheme: dark;
                }
                html[data-kanban-dark="true"] input[type="date"] {
                    color-scheme: dark;
                }
                html[data-kanban-dark="true"] input[type="time"] {
                    color-scheme: dark;
                }
            ` : `
                html[data-kanban-dark="false"] input[type="datetime-local"] {
                    color-scheme: light;
                }
                html[data-kanban-dark="false"] input[type="date"] {
                    color-scheme: light;
                }
                html[data-kanban-dark="false"] input[type="time"] {
                    color-scheme: light;
                }
            `}
        `;

        const styleElement = document.createElement('style');
        styleElement.id = styleId;
        styleElement.textContent = darkModeStyles;
        document.head.appendChild(styleElement);

        // Устанавливаем атрибут на HTML для глобального управления
        document.documentElement.setAttribute('data-kanban-dark', darkMode.toString());

        return () => {
            const style = document.getElementById(styleId);
            if (style) {
                style.remove();
            }
            document.documentElement.removeAttribute('data-kanban-dark');
        };
    }, [darkMode]);

    // Состояние для фантомных линий
    const [showFiders, setShowFiders] = useState(JSON.parse(localStorage.getItem('layers') || '{}')?.dataLayers?.viewPlan ?? false);
    // Состояния для поиска и фильтрации
    const [searchQuery, setSearchQuery] = useState(storedSettings.searchQuery ?? '');
    const deferredSearchQuery = useDeferredValue(searchQuery);

    // Состояния для сортировки
    const [sortMode, setSortMode] = useState(storedSettings.sortMode ?? 'created_desc'); // 'id_desc', 'id_asc', 'created_desc', 'created_asc', 'deadline_desc', 'deadline_asc'

    // Состояния для продвинутой фильтрации
    const [advancedFilters, setAdvancedFilters] = useState(storedSettings.advancedFilters ?? []);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    // Состояния для работы с полигонами
    const [polygon, setPolygon] = useState(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [bounds, setBounds] = useState(null);
    const [isMinimized, setIsMinimized] = useState(false);
    const polygonRef = useRef(null);
    const drawingRef = useRef(null);

    // const electricity = useSelector(state => state.state.electricity)
    const specs_new = useSelector(state => state.state.specs_new)

    // Получаем данные объектов из Redux
    const { pillars, transformers, pillarsZvz, pillarsOpn, fiders, pillarsRlnd, specs } = useSelector(
        (state) => ({
            pillars: state.state.electricity.pillars,
            transformers: state.state.electricity.transformers,
            pillarsZvz: state.state.electricity.pillarsZvz,
            pillarsOpn: state.state.electricity.pillarsOpn,
            fiders: state.state.electricity.fiders,
            pillarsRlnd: state.state.electricity.pillarsRlnd,
            specs: state.state.specs
        }),
        (l, r) => JSON.stringify(l.pillars) === JSON.stringify(r.pillars) &&
            JSON.stringify(l.transformers) === JSON.stringify(r.transformers) &&
            JSON.stringify(l.pillarsZvz) === JSON.stringify(r.pillarsZvz) &&
            JSON.stringify(l.pillarsOpn) === JSON.stringify(r.pillarsOpn) &&
            JSON.stringify(l.fiders) === JSON.stringify(r.fiders) &&
            JSON.stringify(l.pillarsRlnd) === JSON.stringify(r.pillarsRlnd) &&
            JSON.stringify(l.specs) === JSON.stringify(r.specs)
    );


    // Функции для работы с объектами
    const getLayerName = useCallback((layer) => {
        // console.log(layer)
        switch (layer) {

            case 'pillars': return 'Опоры'
            case 'pillars04':
            case 'pillar04': return 'Опоры 0,4кВ'
            case 'pillars10':
            case 'pillar10': return 'Опоры 10кВ'
            case 'pillar04-10':
            case 'pillars04-10': return 'Опоры 0,4-10кВ'
            case 'zvz': return 'Комплект адапетров ВЗ'
            case 'opn': return 'Комплект ОПН'
            case 'rlnd': return 'РЛНД'
            case 'fider':
            case 'fiders': return 'ВЛ'
            case 'fider04':
            case 'fiders04': return 'ВЛ 0,4кВ'
            case 'fider10':
            case 'fiders10': return 'ВЛ 10кВ'
            default: return 'Неизвестный тип'
        }
    }, []);

    const getObjectName = useCallback((type, obj) => {
        switch (type) {
            case 'pillar':
            case 'pillars': return obj?.name
            case 'zvz': return pillars.find(p => p.fid.toString() === obj?.closest_pillar_id.toString())?.name
            case 'opn': return pillars.find(p => p.fid.toString() === obj?.closest_pillar_id.toString())?.name
            case 'rlnd': return pillars.find(p => p.fid.toString() === obj?.closest_pillar_id.toString())?.name
            case 'fider':
            case 'fiders': return obj?.layer
            default: return 'Неизвестный объект'
        }
    }, [pillars, pillarsZvz, pillarsOpn, pillarsRlnd, fiders])

    // Функции для проверки прав доступа
    const canCreateTasks = useMemo(() => {
        return user.roles.some(r => ['admin', 'project_manager', 'user'].includes(r));
    }, [user]);

    const canEditTask = useCallback((task) => {
        if (user.roles.includes('viewer')) return false;
        if (user.roles.some(r => ['admin', 'project_manager'].includes(r))) return true;
        return Number(task.creator) === Number(user.id) || Number(task.responsible) === Number(user.id);
    }, [user]);

    const canDragTask = useCallback((task, taskStatus = null) => {
        if (user.roles.includes('viewer')) return false;

        // Запрещаем перетаскивание копий просроченных задач - они только для отображения
        if (task.isOverdueCopy) return false;

        if (user.roles.some(r => ['admin', 'project_manager'].includes(r))) return true;
        return Number(task.creator) === Number(user.id) || Number(task.responsible) === Number(user.id);

    }, [user]);

    const isAdmin = useMemo(() => {
        return user.roles.includes('admin');
    }, [user]);

    const canDeleteTask = useCallback((task) => {
        return user.roles.includes('admin');
    }, [user]);


    // Состояния для управления ролями
    const [users, setUsers] = useState([]);

    //
    const usersMap = useMemo(() => {
        return new Map(users.map(u => ([u.id, u.name])))
    }, [users])

    console.log(usersMap)

    // Доступные фильтры для задач
    const availableFilters = useMemo(() => ([
        { id: 'name', label: 'Название задачи', type: 'text' },
        { id: 'desc', label: 'Описание задачи', type: 'text' },
        { id: 'status', label: 'Статус', type: 'multi-select', options: statusDefs.map(status => ({ id: status.id, name: status.name, label: status.name })) },
        { id: 'responsible', label: 'Ответственный', type: 'multi-select', options: users.map(user => ({ id: user.id, name: user.name, label: user.name })) },
        { id: 'creator', label: 'Создатель', type: 'multi-select', options: users.map(user => ({ id: user.id, name: user.name, label: user.name })) },
        { id: 'deadline', label: 'Срок выполнения', type: 'date' },
        { id: 'created_at', label: 'Дата создания', type: 'date' },
        { id: 'updated_at', label: 'Дата обновления', type: 'date' }
    ]), [users, statusDefs]);

    // Преобразуем задачи из Redux в структуру канбан
    const [tasks, setTasks] = useState({
        new: [],
        overdue: [],
        progress: [],
        review: [],
        done: [],
        paused: [],
        cancelled: []
    });

    // Мемоизируем фильтрацию и сортировку задач
    const filteredTasks = useMemo(() => {
        let filtered = reduxTasks;

        // Применяем поиск
        if (deferredSearchQuery.trim()) {
            const query = deferredSearchQuery.toLowerCase();
            filtered = filtered.filter(task => {
                const titleMatch = (task.title || task.name || '').toLowerCase().includes(query);
                const descMatch = (task.description || task.desc || '').toLowerCase().includes(query);
                const responsibleMatch = (task.responsible?.name || '').toLowerCase().includes(query);

                // Поиск по ID (точное совпадение числа или с префиксом #)
                const queryWithoutHash = query.replace(/^#/, '');
                const idMatch = queryWithoutHash === task.id.toString() ||
                    task.id.toString().includes(queryWithoutHash);

                return titleMatch || descMatch || responsibleMatch || idMatch;
            });
        }



        // Применяем продвинутую фильтрацию
        if (advancedFilters && advancedFilters.length > 0) {
            advancedFilters.forEach(filter => {
                switch (filter.id) {
                    case 'name':
                        if (filter.value && filter.value !== '') {
                            const query = filter.value.toLowerCase();
                            filtered = filtered.filter(task => {
                                const name = (task.name || task.title || '').toLowerCase();
                                switch (filter.operator) {
                                    case 'contains':
                                        return name.includes(query);
                                    case 'not_contains':
                                        return !name.includes(query);
                                    case 'equals':
                                        return name === query;
                                    case 'not_equals':
                                        return name !== query;
                                    default:
                                        return true;
                                }
                            });
                        }
                        break;
                    case 'desc':
                        if (filter.value && filter.value !== '') {
                            const query = filter.value.toLowerCase();
                            filtered = filtered.filter(task => {
                                const desc = (task.desc || task.description || '').toLowerCase();
                                switch (filter.operator) {
                                    case 'contains':
                                        return desc.includes(query);
                                    case 'not_contains':
                                        return !desc.includes(query);
                                    case 'equals':
                                        return desc === query;
                                    case 'not_equals':
                                        return desc !== query;
                                    default:
                                        return true;
                                }
                            });
                        }
                        break;
                    case 'status':
                        if (filter.value && Array.isArray(filter.value) && filter.value.length > 0) {
                            filtered = filtered.filter(task => filter.value.includes(task.status));
                        }
                        break;
                    case 'responsible':
                        if (filter.value && filter.value.length > 0) {
                            const ids = filter.value.map(r => r.id);
                            filtered = filtered.filter(item => {
                                if (!item.responsible) return false;

                                if (filter.logic === 'and') {
                                    // И - все выбранные значения должны присутствовать
                                    return ids.includes(item.responsible);
                                } else {
                                    // ИЛИ - любое из выбранных значений
                                    return ids.includes(item.responsible);
                                }
                            });
                        }
                        break;
                    case 'creator':
                        if (filter.value && filter.value.length > 0) {
                            const ids = filter.value.map(r => r.id);
                            filtered = filtered.filter(item => {
                                if (!item.responsible) return false;

                                if (filter.logic === 'and') {
                                    // И - все выбранные значения должны присутствовать
                                    return ids.includes(item.creator);
                                } else {
                                    // ИЛИ - любое из выбранных значений
                                    return ids.includes(item.creator);
                                }
                            });
                        }
                        break;
                    case 'deadline':
                        if (filter.value) {
                            const filterDate = new Date(filter.value);
                            filtered = filtered.filter(task => {
                                if (!task.deadline) return false;
                                const taskDate = new Date(task.deadline);
                                switch (filter.operator) {
                                    case 'equals':
                                        return taskDate.toDateString() === filterDate.toDateString();
                                    case 'greater':
                                        return taskDate > filterDate;
                                    case 'less':
                                        return taskDate < filterDate;
                                    default:
                                        return true;
                                }
                            });
                        }
                        break;
                    case 'created_at':
                        if (filter.value) {
                            const filterDate = new Date(filter.value);
                            filtered = filtered.filter(task => {
                                if (!task.created_at) return false;
                                const taskDate = new Date(task.created_at);
                                switch (filter.operator) {
                                    case 'equals':
                                        return taskDate.toDateString() === filterDate.toDateString();
                                    case 'greater':
                                        return taskDate > filterDate;
                                    case 'less':
                                        return taskDate < filterDate;
                                    default:
                                        return true;
                                }
                            });
                        }
                        break;
                    case 'updated_at':
                        if (filter.value) {
                            const filterDate = new Date(filter.value);
                            filtered = filtered.filter(task => {
                                if (!task.updated_at) return false;
                                const taskDate = new Date(task.updated_at);
                                switch (filter.operator) {
                                    case 'equals':
                                        return taskDate.toDateString() === filterDate.toDateString();
                                    case 'greater':
                                        return taskDate > filterDate;
                                    case 'less':
                                        return taskDate < filterDate;
                                    default:
                                        return true;
                                }
                            });
                        }
                        break;
                }
            });
        }

        // Применяем сортировку (создаем копию массива для избежания мутации)
        filtered = [...filtered].sort((a, b) => {
            let valueA, valueB;
            const [sortBy, sortOrder] = sortMode.split('_');

            if (sortBy === 'created') {
                valueA = new Date(a.created_at || a.created || 0);
                valueB = new Date(b.created_at || b.created || 0);
            } else if (sortBy === 'deadline') {
                valueA = new Date(a.deadline || '9999-12-31'); // Задачи без дедлайна в конец
                valueB = new Date(b.deadline || '9999-12-31');
            } else if (sortBy === 'id') {
                valueA = parseInt(a.id) || 0;
                valueB = parseInt(b.id) || 0;
            }

            if (sortOrder === 'asc') {
                return valueA - valueB;
            } else {
                return valueB - valueA;
            }
        });

        return filtered;
    }, [reduxTasks, deferredSearchQuery, sortMode, user, advancedFilters]);

    // Мемоизируем канбан задачи
    const kanbanTasks = useMemo(() => {
        const today = new Date();
        today.setHours(23, 59, 59, 999); // Конец текущего дня

        // Создаем копии просроченных задач для колонки overdue
        const overdueTasks = filteredTasks
            .filter(task => {
                // Берем просроченные задачи из всех статусов кроме завершенных и отмененных
                if (task.status === 'done' || task.status === 'cancelled') return false;
                return task.deadline && new Date(task.deadline) < today;
            })
            .map(task => ({
                ...task,
                id: `overdue-${task.id}`, // Уникальный ID для копии
                isOverdueCopy: true, // Флаг для идентификации копии
                originalId: task.id, // Сохраняем исходный ID
                originalStatus: task.status // Сохраняем исходный статус
            }));

        return {
            new: filteredTasks.filter(task => task.status === 'new'),
            overdue: overdueTasks, // Массив копий просроченных задач
            progress: filteredTasks.filter(task => task.status === 'progress'),
            review: filteredTasks.filter(task => task.status === 'review'),
            done: filteredTasks.filter(task => task.status === 'done'),
            paused: filteredTasks.filter(task => task.status === 'paused'),
            cancelled: filteredTasks.filter(task => task.status === 'cancelled')
        };
    }, [filteredTasks]);



    // Синхронизируем задачи из мемоизированного объекта
    useEffect(() => {
        setTasks(kanbanTasks);
    }, [kanbanTasks]);


    //Данные текущей задачи
    const [currentTask, setCurrentTask] = useState(null);
    const [taskData, setTaskData] = useState(null);
    const [taskObjects, setTaskObjects] = useState(null);
    // Состояния для диалогов
    const [createDialogOpen, setCreateDialogOpen] = useState(false);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [specsDialogOpen, setSpecsDialogOpen] = useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [filesDialogOpen, setFilesDialogOpen] = useState(false);
    const [deletedTasksDialogOpen, setDeletedTasksDialogOpen] = useState(false);
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
    // const [roleManagementOpen, setRoleManagementOpen] = useState(false);



    const [currentTaskSpecs, setCurrentTaskSpecs] = useState(null);
    const [currentTaskFiles, setCurrentTaskFiles] = useState(null);

    const [archivedTasks, setArchivedTasks] = useState([]);
    const [loadingArchive, setLoadingArchive] = useState(false);




    // Состояния формы
    const [formData, setFormData] = useState({
        name: '',
        desc: '',
        deadline: '',
        responsible: null,
        coexecutors: []
    });






    // Обработчик закрытия окна
    const handleClose = useCallback(() => {
        // Очищаем полигон при закрытии
        if (polygonRef.current && map) {
            map.removeLayer(polygonRef.current);
            setPolygon(null);
            setBounds(null);
        }
        if (isDrawing) {
            setIsDrawing(false);
        }
        if (isMinimized) {
            setIsMinimized(false);
        }
        dispatch(setModal(null));
    }, [map, isDrawing, isMinimized, dispatch]);

    // Инициализация рисования полигонов
    useEffect(() => {
        if (map && !drawingRef.current) {
            drawingRef.current = new L.Draw.Polygon(map, {
                shapeOptions: {
                    color: '#7cb342',
                    weight: 3,
                    opacity: 0.8,
                    fillOpacity: 0.3,
                    fillColor: '#7cb342'
                },

            });
        }
    }, [map]);

    // Управление режимом рисования
    useEffect(() => {
        if (!map || !drawingRef.current) return;

        if (isDrawing) {
            drawingRef.current.enable();
            map.fire('signal:drawing', { source: 'kanban', state: true });
        } else {
            drawingRef.current.disable();
            map.fire('signal:drawing', { source: 'kanban', state: false });
        }
    }, [isDrawing, map]);

    // Эффект для управления фантомными линиями
    useEffect(() => {
        if (!map) return;
        // console.log(showFiders)
        if (showFiders) {
            // map.fire('phantom:show');
            map.fire('datalayerchange', { name: 'viewPlan', state: true })
        } else {
            // map.fire('phantom:hide');
            map.fire('datalayerchange', { name: 'viewPlan', state: false })
        }
    }, [showFiders, map]);

    // Сохранение настроек в localStorage при изменении
    useEffect(() => {
        storeSettings({ darkMode });
    }, [darkMode]);

    useEffect(() => {
        storeSettings({ isOverdueCollapsed });
    }, [isOverdueCollapsed]);

    useEffect(() => {
        storeSettings({ viewMode });
    }, [viewMode]);

    useEffect(() => {
        storeSettings({ searchQuery });
    }, [searchQuery]);

    useEffect(() => {
        storeSettings({ sortMode });
    }, [sortMode]);

    useEffect(() => {
        storeSettings({ showFiders });
    }, [showFiders]);

    useEffect(() => {
        storeSettings({ advancedFilters });
    }, [advancedFilters]);

    //Перехват событий нанесения точек на карту
    useEffect(() => {
        if (!map) return
        const handleDrawCreated = (e) => {
            if (isDrawing) {

                // Удаляем предыдущий контур если есть
                if (polygonRef.current) {
                    map.removeLayer(polygonRef.current);
                }

                polygonRef.current = e.layer;
                polygonRef.current.options.data = 'kanban-contour';
                map.addLayer(polygonRef.current);
                polygonRef.current.editing.enable();
                setPolygon(polygonRef.current);
                setBounds(polygonRef.current.getBounds());
            }
        }
        const handleDrawEditVertex = (e) => {
            console.log(e)
            if (!polygonRef.current || !isDrawing) return;
            setBounds(new L.LatLngBounds(polygonRef.current.getLatLngs()))
            setPolygon(new L.Polygon(polygonRef.current.getLatLngs()))
        }

        map.on('draw:created', handleDrawCreated);
        map.on('draw:editvertex', handleDrawEditVertex);

        return () => {
            map.off('draw:created', handleDrawCreated);
            map.off('draw:editvertex', handleDrawEditVertex);
        };
    }, [map, isDrawing]);


    // Функция для определения точки в полигоне
    const isPointInPolygonRayCasting = (latlng, polygonLayer) => {
        const polygon = polygonLayer.getLatLngs()[0];
        const x = latlng.lat;
        const y = latlng.lng;
        let inside = false;

        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const xi = polygon[i].lat;
            const yi = polygon[i].lng;
            const xj = polygon[j].lat;
            const yj = polygon[j].lng;

            if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) {
                inside = !inside;
            }
        }

        return inside;
    };

    const getObjectsFullSpecs = useCallback((data) => {
        if (!data || !data.objects) return null;
        const objects = data.objects
        const hidePillars = data.hidePillars || []
        // const pillarsF = objects.pillars?.map(pb => pillars.find(p => p.fid === pb)).filter(f => f).map(p => ({ ...p, spec: specs?.pillars?.find(s => s.id === p.spec) })) || []
        // const pillarsH = hidePillars.map(pb => pillars.find(p => p.fid === pb)).filter(f => f).map(p => ({ ...p, spec: specs?.pillars?.find(s => s.id === p.spec) })) || []

        const pillarsF = objects.pillars?.map(pb => pillars.find(p => p.fid === pb)).filter(f => f)
        const pillarsH = hidePillars.map(pb => pillars.find(p => p.fid === pb)).filter(f => f)


        const fidersFiltered = fiders.filter(f => objects.pillars.some(pui => f.connected?.find(c => c && c.type === 'pillar' && c.id === pui)))
        const fidersF = []
        fidersFiltered.forEach(f => {
            // const connec = f.connected
            let connectedObjects = []
            for (let index = 0; index < f.connected.length - 1; index++) {
                if (!f.connected[index] || !f.connected[index + 1]) continue;
                if (f.connected[index].id === f.connected[index + 1].id) continue;
                connectedObjects.push([f.connected[index], f.connected[index + 1], index])
            }

            // Создание сегментов фидеров
            connectedObjects.map(cp => {
                const object1 = cp[0].type === 'pillar' ? [...pillarsF, ...pillarsH].find(p => p.fid === cp[0].id) : transformers.find(p => p.fid === cp[0].id)
                const object2 = cp[1].type === 'pillar' ? [...pillarsF, ...pillarsH].find(p => p.fid === cp[1].id) : transformers.find(p => p.fid === cp[1].id)
                if (object1 && object2) {
                    if (object1.fid === object2.fid) return;
                    if (!object1.spec || !specs_new[object1.spec] || !object2.spec || !specs_new[object2.spec]) return;
                    const object1Chains = cp[0].type === 'pillar' ? (specs_new[object1.spec]?.[Number(object1.spec_complect)]?.chains || Object.values(specs_new[object1.spec])[0]?.chains || 1) : Infinity
                    const object2Chains = cp[1].type === 'pillar' ? (specs_new[object2.spec]?.[Number(object2.spec_complect)]?.chains || Object.values(specs_new[object2.spec])[0]?.chains || 1) : Infinity
                    // Определение количества цепей
                    let quantity = Math.min(object1Chains, object2Chains)

                    const distance = object1?.connected?.find(c => c.id === object2.fid)?.distance || object2?.connected?.find(c => c.id === object1.fid)?.distance || 0
                    fidersF.push({
                        fid: f.id,
                        type: f.type,
                        layer: f.layer,
                        // pillars: [object1.fid, object2.fid],
                        object1,
                        object2,
                        spec: f.spec,
                        chains: quantity,
                        distance: Math.round(distance * 100) / 100
                    })
                }
            })
        })

        const zvzF = objects.zvz.map(z => pillarsZvz.find(pz => pz.fid === z))
        const opnF = objects.opn.map(z => pillarsOpn.find(pz => pz.fid === z))
        const rlndF = objects.rlnd.map(z => pillarsRlnd.find(pz => pz.fid === z))

        return {
            transformers: transformers.find(t => t.fid.toString() === pillarsF.find(p => p.tp_id)?.tp_id),
            pillars04: pillarsF.filter(p => p.type === 'pillar04'),
            pillars10: pillarsF.filter(p => p.type === 'pillar10'),
            pillars04_10: pillarsF.filter(p => p.type === 'pillar04-10'),
            pillars: pillarsF,
            zvz: zvzF,
            opn: opnF,
            rlnd: rlndF,
            fiders: fidersF,
            fiders04: fidersF.filter(f => f.type === 'fider04'),
            fiders10: fidersF.filter(f => f.type === 'fider10'),
        };
    }, [pillars, transformers, pillarsZvz, pillarsOpn, pillarsRlnd, fiders]);

    // Функция поиска объектов в границах полигона
    const findObjectsInBounds = useCallback(() => {
        if (!polygon || !map) return null;

        const planTasks = reduxTasks.filter(task => task.type === 'contour')

        //Объекты уже задействованные в других задачах
        const usedObjects = {
            pillars: planTasks.map(task => task.data?.objects?.pillars || []).flat(),
            zvz: planTasks.map(task => task.data?.objects?.zvz || []).flat(),
            opn: planTasks.map(task => task.data?.objects?.opn || []).flat(),
            rlnd: planTasks.map(task => task.data?.objects?.rlnd || []).flat()
        }

        //Объекты данной задачи учитываемые при формировании материолов
        const objectsB = {
            pillars: new Set(),
            zvz: new Set(),
            opn: new Set(),
            rlnd: new Set(),
        }

        //Исключаемые из данной задачи объекты
        const objectsE = {
            pillars: new Set(),
            zvz: new Set(),
            opn: new Set(),
            rlnd: new Set()
        }

        //Опоры не учитваемы при формировании материалов, но нужные для рисования линии
        const hidePillars = new Set()

        //КТП 
        const transformersB = new Set()


        function findAndDistributeObject(arr, type, option) {
            const target = arr.find(p => p.fid === option);
            if (target) {
                if (!usedObjects[type].includes(target.fid)) {
                    objectsB[type].add(target.fid);
                } else {
                    objectsE[type].add(target.fid);
                }
                if (target.tp_id) transformersB.add(Number(target.tp_id))
            }
        }

        const fidersInBounds = new Set()

        map.eachLayer(layer => {
            if (layer.options && layer.options.type) {
                switch (layer.options.type) {
                    case 'pillar04':
                    case 'pillar04-10':
                    case 'pillar10':
                        if (isPointInPolygonRayCasting(layer.getLatLng(), polygon)) {
                            findAndDistributeObject(pillars, 'pillars', layer.options.data)
                        }
                        break;
                    case 'zvz':
                        if (isPointInPolygonRayCasting(layer.getLatLng(), polygon)) {
                            findAndDistributeObject(pillarsZvz, 'zvz', layer.options.data)
                        }
                        break;
                    case 'opn':
                        if (isPointInPolygonRayCasting(layer.getLatLng(), polygon)) {
                            findAndDistributeObject(pillarsOpn, 'opn', layer.options.data)
                        }
                        break;
                    case 'rlnd':
                        if (isPointInPolygonRayCasting(layer.getLatLng(), polygon)) {
                            findAndDistributeObject(pillarsRlnd, 'rlnd', layer.options.data)
                        }
                        break;
                    case 'fider04':
                    case 'fider10':
                    case 'fider6':
                    case 'fider10-04':
                        fidersInBounds.add(layer.options.data)
                        break;
                    case 'cluster':
                        layer.getLayers().forEach(l => {
                            switch (l.options.type) {
                                case 'pillar04':
                                case 'pillar04-10':
                                case 'pillar10':
                                    if (isPointInPolygonRayCasting(l.getLatLng(), polygon)) {
                                        findAndDistributeObject(pillars, 'pillars', l.options.data)
                                    }
                                    break;
                                case 'zvz':
                                    if (isPointInPolygonRayCasting(l.getLatLng(), polygon)) {
                                        findAndDistributeObject(pillarsZvz, 'zvz', l.options.data)
                                    }
                                    break;
                                case 'opn':
                                    if (isPointInPolygonRayCasting(l.getLatLng(), polygon)) {
                                        findAndDistributeObject(pillarsOpn, 'opn', l.options.data)
                                    }
                                    break;
                                case 'rlnd':
                                    if (isPointInPolygonRayCasting(l.getLatLng(), polygon)) {
                                        findAndDistributeObject(pillarsRlnd, 'rlnd', l.options.data)
                                    }
                                    break;
                            }
                        });
                        break;
                }
            }
        });

        console.log(fidersInBounds)
        console.log(fiders)
        // Находим связанные фидеры
        const fidersB = fiders.filter(f => fidersInBounds.has(f.id) && f.connected?.find(p => p?.type === 'pillar' && objectsB.pillars.has(p?.id))).filter(f => {
            if (f.connected?.length === 2 && f.connected[0]?.id === f.connected[1]?.id) {
                return false;
            }
            return true;
        })

        fidersB.forEach(fider => {
            if (!fider.connected) return
            const forAddToObjects = new Set()
            fider.connected.map((c, i) => {
                if (!c) return
                const toCheck = []
                if (c.type === 'pillar' && objectsB.pillars.has(c.id)) {
                    if (i !== 0 && fider.connected[i - 1] && fider.connected[i - 1].type === 'pillar') toCheck.push(fider.connected[i - 1])
                    if (i !== fider.connected.length - 1 && fider.connected[i + 1] && fider.connected[i + 1].type === 'pillar') toCheck.push(fider.connected[i + 1])
                    toCheck.map(check => {
                        if (!usedObjects.pillars.includes(check.id) || !objectsE.pillars.has(check.id)) {
                            // objectsB.pillars.add(check.id)
                            forAddToObjects.add(check.id)
                        } else {
                            hidePillars.add(check.id)
                        }
                    })

                }
            })
            objectsB.pillars = new Set([...objectsB.pillars, ...forAddToObjects])
        })



        const data = {
            objects: {
                pillars: [...objectsB.pillars],
                zvz: [...objectsB.zvz],
                opn: [...objectsB.opn],
                rlnd: [...objectsB.rlnd],
                fiders: [...new Set(fidersB.map(f => f.id))],
            },
            hidePillars: [...hidePillars],
            transformers: [...transformersB]

        }
        const excludedObjects = {
            pillars: [...objectsE.pillars],
            zvz: [...objectsE.zvz],
            opn: [...objectsE.opn],
            rlnd: [...objectsE.rlnd],

        }
        console.log(data, excludedObjects)

        return [data, excludedObjects];
    }, [polygon, map, pillars, pillarsZvz, pillarsOpn, pillarsRlnd, fiders, specs]);

    //Сигнал для скрытия всех контролов
    const hideAllControls = useCallback(() => {
        const toDisable = ['map-controls']
        toDisable.map((cl) => {
            const el = document.getElementsByClassName(cl)[0]
            if (el) el.style.display = 'none'
        })
    }, [])

    //Сигнал для показа всех контролов
    const showAllControls = useCallback(() => {
        const toDisable = ['map-controls']
        toDisable.map((cl) => {
            const el = document.getElementsByClassName(cl)[0]
            if (el) el.style.display = ''
        })
    }, [])

    // Обработчик создания задачи по контуру
    const handleCreateTaskByContour = useCallback(() => {
        //Скрываем все контролы
        hideAllControls()
        // Сворачиваем основное диалоговое окно и начинаем рисование
        setIsMinimized(true);
        setIsDrawing(true);
    }, []);

    // Обработчик отмены рисования контура
    const handleCancelContour = useCallback(() => {
        showAllControls()
        setIsDrawing(false);
        setIsMinimized(false);
        if (polygonRef.current && map) {
            map.removeLayer(polygonRef.current);
            setPolygon(null);
            setBounds(null);
        }
    }, [map]);

    // Обработчик подтверждения контура
    const handleConfirmContour = useCallback(() => {
        if (!polygon) return;

        //Находим все обхекты в выделенной области
        const [data, _] = findObjectsInBounds();
        //Для всех найденный объектов формируем спецификации
        const objects = getObjectsFullSpecs(data)
        showAllControls();
        // Подсчитываем количество найденных объектов
        const totalFidersDistance = objects.fiders?.reduce((acc, curr) => acc + curr.distance, 0) || 0
        const totalFiders04Distance = objects.fiders04?.reduce((acc, curr) => acc + curr.distance, 0) || 0
        const totalFiders10Distance = objects.fiders10?.reduce((acc, curr) => acc + curr.distance, 0) || 0
        setFormData({
            name: `План * на ${objects.transformers.name} ${objects.transformers.town} ${Number(totalFidersDistance / 1000).toFixed(2).replace('.', ',')} км и ${objects.pillars.length} опор`,
            desc: `План работ на ${objects.transformers.name} ${objects.transformers.town}\n${objects.pillars?.length > 0 ? `Опоры 0,4кВ: ${objects.pillars04?.length} шт\n` : ''}${totalFiders04Distance > 0 ? `ВЛ 0,4кВ: ${Number(totalFiders04Distance / 1000).toFixed(2).replace('.', ',')} км\n` : ''}${objects.pillars10?.length > 0 ? `Опоры 10кВ: ${objects.pillars10?.length} шт\n` : ''}${totalFiders10Distance > 0 ? `ВЛ 10кВ: ${Number(totalFiders10Distance / 1000).toFixed(2).replace('.', ',')} км\n` : ''}${objects.pillars04_10?.length > 0 ? `Опоры 0,4-10кВ: ${objects.pillars04_10?.length} шт\n` : ''}${objects.zvz?.length > 0 ? `Комплект адаптеров ВЗ: ${objects.zvz?.length} шт\n` : ''}${objects.opn?.length > 0 ? `Комплект ОПН: ${objects.opn?.length} шт\n` : ''}${objects.rlnd?.length > 0 ? `РЛНД: ${objects.rlnd?.length} шт\n` : ''}`,
            deadline: '',
            responsible: null
        });
        setTaskData(data)
        setTaskObjects(objects)
        setIsDrawing(false);
        setIsMinimized(false);
        setCreateDialogOpen(true);
    }, [polygon, findObjectsInBounds, showAllControls]);

    // Обработчик открытия диалога создания задачи
    const openCreateTaskDialog = () => {
        resetForm();
        setCreateDialogOpen(true);
    };

    // Обработчик создания задачи с отправкой на сервер
    const handleCreateTask = async (data) => {
        console.log('handleCreateTask', data)
        if (!data.name.trim() || !data.responsible || !data.deadline) return;

        // Создаем задачу локально
        const newTask = {
            id: Date.now(), // Временный ID
            title: data.name,
            description: data.desc,
            deadline: data.deadline,
            responsible: data.responsible,
            coexecutors: data.coexecutors || [],
            creator: user.id,
            status: 'new',
            created_at: new Date().toISOString(),
            project_id: null, // Можно добавить выбор проекта позже
            // objects: newTaskObjects
            data: taskData,
            type: taskData?.objects ? 'contour' : 'normal'
        };

        // Добавляем в Redux
        dispatch(addTask(newTask));
        setCreateDialogOpen(false);
        resetForm();

        // Пытаемся отправить на сервер
        if (auth.isAuthenticated && auth.user?.access_token) {
            try {
                const taskPayload = {
                    title: newTask.title,
                    description: newTask.description,
                    deadline: newTask.deadline,
                    responsible: newTask.responsible,
                    creator: newTask.creator,
                    status: newTask.status,
                    project_id: newTask.project_id,
                    data: newTask.data,
                    type: newTask.type || 'normal',
                    coexecutors: newTask.coexecutors || []
                };

                const response = await $authHost.post('/apig/tasks', taskPayload);

                if (response.data.success) {
                    // Обновляем ID задачи серверным
                    dispatch(updateTaskId({
                        oldTaskId: newTask.id,
                        newTaskId: response.data.data.id
                    }));

                    //Если задача по контуру обновляем все данные вдобавок
                    if (newTask.data) {
                        dispatch(updateTask(response.data.data))
                    }

                } else {
                    throw new Error('Server returned unsuccessful response');
                }
            } catch (err) {
                console.error('Ошибка синхронизации задачи:', err);
                // Добавляем в очередь для повторной синхронизации
                dispatch(addTaskToQueue({
                    action: 'create',
                    task: newTask,
                    originalTaskId: newTask.id,
                    timestamp: Date.now()
                }));
            }
        } else {
            // Нет авторизации - добавляем в очередь
            dispatch(addTaskToQueue({
                action: 'create',
                task: newTask,
                originalTaskId: newTask.id,
                timestamp: Date.now()
            }));
        }
    };

    // Обработчик открытия диалога редактирования
    const handleEditTask = useCallback((task) => {
        setCurrentTask(task);
        setFormData({
            name: task.title || task.name || '',
            desc: task.description || task.desc || '',
            deadline: task.deadline || '',
            responsible: task.responsible || null,
            coexecutors: task.coexecutors || [],
            creator: task.creator || null
        });
        setTaskData(task.data)
        setTaskObjects(getObjectsFullSpecs(task.data))
        setEditDialogOpen(true);
    }, [getObjectsFullSpecs]);

    const handleUpdateFiles = useCallback((files) => {
        if (!files || !currentTaskFiles) return;
        const updatedTask = {
            ...currentTaskFiles,
            files
        }
        dispatch(updateTask(updatedTask));
        setCurrentTaskFiles(updatedTask)
    })

    // Обработчик сохранения изменений задачи с отправкой на сервер
    const handleSaveTask = async (data) => {
        if (!data.name.trim() || !data.responsible || !currentTask || !data.deadline) return;

        const updatedTaskData = {
            title: data.name,
            description: data.desc,
            deadline: data.deadline,
            responsible: data.responsible,
            coexecutors: data.coexecutors || [],
            files: data.files,
            editor: user.id,
            edited_at: new Date(),
            // Добавляем информацию о редакторе
        };

        const updatedTask = {
            ...currentTask,
            ...updatedTaskData
        };

        // Обновляем в Redux
        console.log(updateTask)
        dispatch(updateTask(updatedTask));
        setEditDialogOpen(false);
        resetForm();

        // Пытаемся синхронизировать с сервером
        if (auth.isAuthenticated && auth.user?.access_token && !currentTask.isLocal) {
            try {
                // const updatePayload = {
                //     title: updatedTaskData.title,
                //     description: updatedTaskData.description,
                //     deadline: updatedTaskData.deadline,
                //     responsible: updatedTaskData.responsible,
                //     coexecutors: updatedTaskData.coexecutors,
                //     editor: updatedTaskData.editor,
                //     files: 
                // };

                const response = await $authHost.put(`/apig/tasks/${currentTask.id}`, updatedTaskData);


                if (!response.data.success) {
                    throw new Error('Server returned unsuccessful response');
                }
            } catch (err) {
                console.error('Ошибка синхронизации обновления:', err);
                // Добавляем в очередь для повторной синхронизации
                dispatch(addTaskToQueue({
                    action: 'update',
                    task: updatedTaskData,
                    originalTaskId: currentTask.id,
                    timestamp: Date.now()
                }));
            }
        } else {
            // Локальная задача или нет авторизации - добавляем в очередь
            dispatch(addTaskToQueue({
                action: currentTask.isLocal ? 'create' : 'update',
                task: updatedTaskData,
                originalTaskId: currentTask.isLocal ? null : currentTask.id,
                timestamp: Date.now()
            }));
        }
    };

    // Обработчик открытия диалога спецификаций
    const handleViewSpecs = useCallback((task) => {
        setCurrentTaskSpecs(task);
        setSpecsDialogOpen(true);
    }, []);

    // Обработчик открытия диалога файлов
    const handleViewFiles = useCallback((task) => {
        setCurrentTaskFiles(task);
        setFilesDialogOpen(true);
    }, []);

    const handleSpecsDialogClose = () => {
        setCurrentTaskSpecs(false);
        setSpecsDialogOpen(null);
    };

    const handleFilesDialogClose = () => {
        setCurrentTaskFiles(null);
        setFilesDialogOpen(false);
    };

    // Обработчик открытия диалога подтверждения удаления
    const handleDeleteTask = useCallback((taskId) => {
        const task = reduxTasks.find(task => task.id === taskId);
        setCurrentTask(task);
        setDeleteConfirmOpen(true);
    }, [reduxTasks]);

    // Обработчик подтверждения удаления задачи
    const confirmDeleteTask = async () => {
        if (!currentTask) return;

        const taskId = currentTask.id;

        // Удаляем локально сразу
        dispatch(deleteTask(taskId));

        // Пытаемся синхронизировать с сервером (только если это не локальная задача)
        if (auth.isAuthenticated && auth.user?.access_token && !currentTask.isLocal) {
            try {
                // Используем DELETE запрос для удаления и автоматического архивирования
                const response = await $authHost.delete(`/apig/tasks/${taskId}`, {
                    data: {
                        reason: 'Задача удалена администратором',
                        archived_by_id: user.id
                    }
                });

                if (!response.data.success) {
                    throw new Error('Server returned unsuccessful response');
                }
            } catch (err) {
                console.error('Ошибка синхронизации удаления:', err);
                // Добавляем в очередь для повторной синхронизации
                dispatch(addTaskToQueue({
                    action: 'delete',
                    task: currentTask,
                    originalTaskId: taskId,
                    timestamp: Date.now()
                }));
            }
        } else {
            // Добавляем в очередь для повторной синхронизации
            dispatch(addTaskToQueue({
                action: 'delete',
                task: currentTask,
                originalTaskId: taskId,
                timestamp: Date.now()
            }));
        }

        // Закрываем диалог с небольшой задержкой для правильного управления фокусом
        setTimeout(() => {
            setDeleteConfirmOpen(false);
            setCurrentTask(null);
        }, 0);
    };

    // Обработчик отмены удаления
    const cancelDeleteTask = () => {
        // Закрываем диалог с небольшой задержкой для правильного управления фокусом
        setTimeout(() => {
            setDeleteConfirmOpen(false);
            setCurrentTask(null);
        }, 0);
    };

    // Функция загрузки архивных задач


    // Функция открытия диалога архивных задач
    const handleOpenDeletedTasksDialog = () => {
        setDeletedTasksDialogOpen(true);

    };

    const handleCloseDeletedTasksDialog = () => {
        setDeletedTasksDialogOpen(false);

    };

    // Функции для диалога истории изменений
    const handleOpenHistoryDialog = (task) => {
        setCurrentTask(task);
        setHistoryDialogOpen(true);
    };

    const handleCloseHistoryDialog = () => {
        setHistoryDialogOpen(false);
        setCurrentTask(null);
    };

    // Функции для управления продвинутыми фильтрами
    const handleApplyAdvancedFilters = () => {
        setShowAdvancedFilters(false);
    };

    const handleClearAdvancedFilters = () => {
        setAdvancedFilters([]);
    };

    const getActiveAdvancedFiltersCount = () => {
        return advancedFilters.length;
    };

    const addFilter = (filterId) => {
        const filter = availableFilters.find(f => f.id === filterId);
        if (filter) {
            const newFilter = {
                id: filterId,
                label: filter.label,
                type: filter.type,
                options: filter.options,
                operator: filter.type === 'date' || filter.type === 'number' ? 'equals' :
                    filter.type === 'text' ? 'contains' : null,
                value: filter.type === 'date' || filter.type === 'number' ? null :
                    filter.type === 'multi-select' ? [] : '',
            };
            const newFilters = [...advancedFilters, newFilter];
            setAdvancedFilters(newFilters);
        }
    };

    const removeFilter = (filterId) => {
        const newFilters = advancedFilters.filter(f => f.id !== filterId);
        setAdvancedFilters(newFilters);
    };

    const updateFilter = (filterId, updates) => {
        const newFilters = advancedFilters.map(f =>
            f.id === filterId ? { ...f, ...updates } : f
        );
        setAdvancedFilters(newFilters);
    };

    const getAvailableFiltersForSelect = () => {
        const usedFilterIds = advancedFilters.map(f => f.id);
        return availableFilters.filter(f => !usedFilterIds.includes(f.id));
    };

    const handleNavigateToReestr = () => {
        navigate('/objects_reestr');
    };

    const handleNavigateFieldWorks = () => {
        navigate('/field_works');
    };




    // Обработчик изменения статуса задачи
    const handleStatusChange = useCallback(async (task, newStatus) => {
        const updatedTask = {
            ...task,
            status: newStatus,
            editor: user.id
        };

        // Обновляем в Redux
        dispatch(updateTask(updatedTask));

        // Пытаемся синхронизировать с сервером
        if (auth.isAuthenticated && auth.user?.access_token && !task.isLocal) {
            try {
                const response = await $authHost.put(`/apig/tasks/${task.id}`, updatedTask);

                if (!response.data.success) {
                    throw new Error('Server returned unsuccessful response');
                }
            } catch (err) {
                console.error('Ошибка синхронизации статуса:', err);
                // Добавляем в очередь для повторной синхронизации
                dispatch(addTaskToQueue({
                    action: 'update',
                    task: updatedTask,
                    originalTaskId: task.id,
                    timestamp: Date.now()
                }));
            }
        } else {
            // Локальная задача или нет авторизации - добавляем в очередь
            dispatch(addTaskToQueue({
                action: task.isLocal ? 'create' : 'update',
                task: updatedTask,
                originalTaskId: task.isLocal ? null : task.id,
                timestamp: Date.now()
            }));
        }
    }, [auth.isAuthenticated, auth.user?.access_token, user, dispatch]);

    // Функция для форматирования даты в формат yyyy-MM-ddTHH:mm
    const formatDateForInput = useCallback((dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            // Получаем локальную дату и время в формате ISO
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        } catch {
            return '';
        }
    }, []);

    // Обработчик изменения полей формы
    const handleFormChange = useCallback((field) => (event) => {
        setFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    }, []);

    // Функция сброса формы
    const resetForm = useCallback(() => {
        setFormData({
            name: '',
            desc: '',
            deadline: '',
            responsible: null,
            coexecutors: [],
            creator: null
        });
        // setNewTaskObjects(null);
        setTaskData(null)
        setTaskObjects(null)
        setCurrentTask(null);
    }, []);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await $authHost.get('/apig/users');
                const { success, data } = response.data;

                setUsers(success ? data.map(item => ({
                    id: item.id,
                    name: item.display_name
                })) : []);
            } catch (e) {
                setUsers([])
                console.log(e)
            }
        };
        fetchUsers();
    }, []);



    // Ref для хранения таймеров debounce
    const colorUpdateTimeouts = useRef({});





    // Получить все задачи для таблицы (исключая копии просроченных задач)
    const getAllTasks = () => {
        return statusDefs.flatMap(status => {
            // Исключаем копии просроченных задач из таблицы, чтобы избежать дублирования
            if (status.id === 'overdue') {
                return [];
            }
            return tasks[status.id]
        });
    };



    // Мемоизируем проверку необходимости синхронизации
    const isSyncNeeded = useMemo(() => {
        return tasksQueue.length > 0;
    }, [tasksQueue]);

    // Состояние для загрузки и ошибок синхронизации
    const [syncLoading, setSyncLoading] = useState(false);
    const [syncError, setSyncError] = useState(null);
    const [syncMenuAnchor, setSyncMenuAnchor] = useState(null);

    // Функция синхронизации с сервером
    const syncWithServer = useCallback(async (forcedSync = false) => {
        if (!auth.isAuthenticated || !auth.user?.access_token || tasksQueue.length === 0) {
            return;
        }

        setSyncLoading(true);
        setSyncError(null);
        console.log(`${forcedSync ? 'Принудительная' : 'Автоматическая'} синхронизация с сервером...`);

        let syncedCount = 0;
        let errorCount = 0;
        for (const queueItem of tasksQueue) {
            try {
                const { action, task, originalTaskId } = queueItem;

                switch (action) {
                    case 'create':
                        const createPayload = {
                            title: task.title,
                            description: task.description,
                            deadline: task.deadline,
                            responsible: task.responsible,
                            creator: task.creator,
                            status: task.status,
                            project_id: task.project_id,
                            type: task.type,
                            data: task.data
                        };

                        const createResponse = await $authHost.post('/apig/tasks', createPayload, {
                            headers: { Authorization: `Bearer ${auth.user.access_token}` }
                        });

                        if (createResponse.data.success) {
                            // Обновляем задачу с серверным ID
                            dispatch(updateTaskId({
                                oldTaskId: task.id,
                                newTaskId: createResponse.data.data.id
                            }));
                            // Удаляем из очереди
                            dispatch(removeFromQueue(queueItem));
                            syncedCount++;
                        }
                        break;

                    case 'update':
                        const updatePayload = {
                            title: task.title,
                            description: task.description,
                            deadline: task.deadline,
                            responsible: task.responsible,
                            editor: task.editor,
                            status: task.status,
                            type: task.type,
                            data: task.data
                        };

                        const updateResponse = await $authHost.put(`/apig/tasks/${originalTaskId}`, updatePayload, {
                            headers: { Authorization: `Bearer ${auth.user.access_token}` }
                        });

                        if (updateResponse.data.success) {
                            dispatch(removeFromQueue(queueItem));
                            syncedCount++;
                        }
                        break;

                    case 'delete':
                        const deleteResponse = await $authHost.delete(`/apig/tasks/${originalTaskId}`, {
                            headers: { Authorization: `Bearer ${auth.user.access_token}` },
                            data: {
                                reason: 'Задача удалена администратором',
                                archived_by_id: user.id
                            }
                        });

                        if (deleteResponse.data.success) {
                            dispatch(removeFromQueue(queueItem));
                            syncedCount++;
                        }
                        break;

                    default:
                        console.warn('Неизвестное действие в очереди:', action);
                        errorCount++;
                }
            } catch (err) {
                console.error('Ошибка синхронизации элемента очереди:', err);
                errorCount++;
                // Оставляем элемент в очереди для повторной попытки
            }
        }

        setSyncLoading(false);

        // Показываем результат синхронизации
        if (forcedSync) {
            if (syncedCount > 0 && errorCount === 0) {
                setSyncError(`✅ Синхронизировано задач: ${syncedCount}`);
                setTimeout(() => setSyncError(null), 3000);
            } else if (syncedCount > 0 && errorCount > 0) {
                setSyncError(`⚠️ Синхронизировано: ${syncedCount}, ошибок: ${errorCount}`);
                setTimeout(() => setSyncError(null), 5000);
            } else if (errorCount > 0) {
                setSyncError(`❌ Ошибка синхронизации. Попробуйте позже.`);
                setTimeout(() => setSyncError(null), 5000);
            }
        }
    }, [auth.isAuthenticated, auth.user?.access_token, tasksQueue, dispatch, user.display_name]);

    // Автосинхронизация каждые 30 секунд
    useEffect(() => {
        if (tasksQueue.length === 0) return;

        const interval = setInterval(() => {
            syncWithServer(false);
        }, 30000); // 30 секунд

        return () => clearInterval(interval);
    }, [tasksQueue.length, syncWithServer]);

    // Синхронизация при старте компонента (если есть несинхронизированные задачи)
    useEffect(() => {
        if (tasksQueue.length > 0 && auth.isAuthenticated && auth.user?.access_token) {
            // Небольшая задержка, чтобы компонент успел инициализироваться
            const timeout = setTimeout(() => {
                syncWithServer(false);
            }, 2000);

            return () => clearTimeout(timeout);
        }
    }, [auth.isAuthenticated, auth.user?.access_token, syncWithServer]);

    // Cleanup для debounce таймеров при размонтировании компонента
    useEffect(() => {
        return () => {
            // Очищаем все активные таймеры debounce
            Object.values(colorUpdateTimeouts.current).forEach(timeout => {
                if (timeout) {
                    clearTimeout(timeout);
                }
            });
            colorUpdateTimeouts.current = {};
        };
    }, []);

    // Принудительная синхронизация
    const handleForcedSync = useCallback(() => {
        syncWithServer(true);
    }, [syncWithServer]);

    // Открытие меню синхронизации
    const handleSyncMenuOpen = useCallback((event) => {
        setSyncMenuAnchor(event.currentTarget);
    }, []);

    // Закрытие меню синхронизации
    const handleSyncMenuClose = useCallback(() => {
        setSyncMenuAnchor(null);
    }, []);

    // Синхронизация из меню
    const handleSyncMenuSync = useCallback(() => {
        handleSyncMenuClose();
        syncWithServer(true);
    }, [syncWithServer]);

    // Очистка очереди синхронизации
    const handleSyncMenuClear = useCallback(() => {
        handleSyncMenuClose();
        if (window.confirm('Вы уверены, что хотите очистить очередь синхронизации? Все несохраненные изменения будут потеряны.')) {
            dispatch(clearQueue());
            dispatch(fetchTasks(auth.user?.access_token))
            console.log('🗑️ Очередь синхронизации очищена');
        }
    }, [dispatch]);

    // Наведение на область карты для задачи
    const handleFocusOnTaskArea = useCallback((task) => {
        if (!task.data.objects || !task.data.objects.pillars || task.data.objects.pillars.length === 0) {
            console.warn('У задачи нет объектов опор для наведения');
            return;
        }

        // Получаем координаты всех опор задачи
        const taskCoordinates = [];
        task.data.objects.pillars.forEach(pillarId => {
            const pillar = pillars.find(p => p.fid === pillarId);
            if (pillar && pillar.coords) {
                taskCoordinates.push([pillar.coords[0], pillar.coords[1]]); // [lat, lng]
            }
        });

        if (taskCoordinates.length === 0) {
            console.warn('Не найдены координаты опор для задачи');
            return;
        }

        // Вычисляем bounds
        const lats = taskCoordinates.map(coord => coord[0]);
        const lngs = taskCoordinates.map(coord => coord[1]);

        const minLat = Math.min(...lats);
        const maxLat = Math.max(...lats);
        const minLng = Math.min(...lngs);
        const maxLng = Math.max(...lngs);

        // Добавляем небольшой отступ к bounds
        const padding = 0.001; // примерно 100 метров
        const bounds = [
            [minLat - padding, minLng - padding],
            [maxLat + padding, maxLng + padding]
        ];

        // Закрываем канбан
        handleClose();

        // Наводим карту на область через небольшой timeout для корректного закрытия модала
        setTimeout(() => {
            map.fitBounds(bounds, {
                maxZoom: 18,
                animate: false,
                duration: 1.5
            });
        }, 300);

        console.log(`🎯 Наведение на область задачи "${task.title}" с ${taskCoordinates.length} опорами`);
    }, [pillars, map, handleClose]);

    const ContentHeader = () => {
        return <React.Fragment>
            <Box id="kanban-dialog-title" sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: fromStartPage ? 'end' : 'space-between',
                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                color: darkMode ? '#f5f7fa' : '#333',
                borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
                p: { xs: 0.5, md: 1 },
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 1, sm: 0 }
            }}>
                {!fromStartPage && (
                    <Typography
                        variant="h6"
                        component="span"
                        sx={{
                            pl: { xs: 0, md: 2 },
                            color: darkMode ? '#f5f7fa' : '#333',
                            fontWeight: 600,
                            fontSize: { xs: '1rem', md: '1.25rem' },
                            textAlign: { xs: 'center', sm: 'left' }
                        }}
                    >
                        Задачи проекта
                    </Typography>
                )}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: { xs: 0.5, md: 1 },
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                }}>

                    {/* Кнопка синхронизации с меню */}
                    {isSyncNeeded && (
                        <>
                            <Tooltip title={`Несинхронизированных задач: ${tasksQueue.length}. Нажмите для выбора действия`}>
                                <IconButton
                                    size="small"
                                    onClick={handleSyncMenuOpen}
                                    disabled={syncLoading}
                                    sx={{
                                        color: darkMode ? '#fff' : '#fff',
                                        backgroundColor: darkMode ? '#f57c00' : '#ff9800',
                                        animation: 'pulse 2s infinite',
                                        '&:hover': {
                                            backgroundColor: darkMode ? '#e65100' : '#f57c00'
                                        },
                                        '@keyframes pulse': {
                                            '0%': {
                                                opacity: 1
                                            },
                                            '50%': {
                                                opacity: 0.7
                                            },
                                            '100%': {
                                                opacity: 1
                                            }
                                        }
                                    }}
                                >
                                    {syncLoading ?
                                        <SyncIcon sx={{
                                            animation: 'spin 1s linear infinite',
                                            '@keyframes spin': {
                                                '0%': { transform: 'rotate(0deg)' },
                                                '100%': { transform: 'rotate(360deg)' }
                                            }
                                        }} /> :
                                        <WarningIcon fontSize="small" />
                                    }
                                </IconButton>
                            </Tooltip>
                            <Menu
                                anchorEl={syncMenuAnchor}
                                open={Boolean(syncMenuAnchor)}
                                onClose={handleSyncMenuClose}
                                sx={{
                                    zIndex: 13000
                                }}
                                slotProps={{
                                    paper: {
                                        sx: {
                                            bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            border: `1px solid ${darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'}`,
                                            zIndex: 13002
                                        }
                                    }
                                }}
                            >
                                <MenuItem onClick={handleSyncMenuSync} disabled={syncLoading}>
                                    <SyncIcon sx={{ mr: 1, fontSize: 18 }} />
                                    Синхронизировать ({tasksQueue.length} задач)
                                </MenuItem>
                                <MenuItem onClick={handleSyncMenuClear} disabled={syncLoading}>
                                    <ClearIcon sx={{ mr: 1, fontSize: 18 }} />
                                    Очистить очередь
                                </MenuItem>
                            </Menu>
                        </>
                    )}

                    {/* Кнопка перехода на лог полевых работ */}
                    <Tooltip title="Лог полевых работ">
                        <IconButton
                            size="small"
                            onClick={handleNavigateFieldWorks}
                            sx={{
                                color: darkMode ? '#1976d2' : '#1976d2',
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.08)'
                                }
                            }}
                        >
                            <EngineeringIcon sx={{ color: '#8baa64', fontSize: { xs: 19, md: 24 } }} />
                            {/* <ListAltIcon fontSize="small" /> */}
                        </IconButton>
                    </Tooltip>

                    {/* Кнопка перехода на реестр объектов */}
                    <Tooltip title="Реестр объектов">
                        <IconButton
                            size="small"
                            onClick={handleNavigateToReestr}
                            sx={{
                                color: darkMode ? '#1976d2' : '#1976d2',
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.08)'
                                }
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#8baa64">
                                <path d="M320-240q-33 0-56.5-23.5T240-320v-480q0-33 23.5-56.5T320-880h480q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H320Zm0-80h480v-480H320v480ZM160-80q-33 0-56.5-23.5T80-160v-560h80v560h560v80H160Zm160-720v480-480Zm240 240q-17 0-28.5-11.5T520-600q0-17 11.5-28.5T560-640q17 0 28.5 11.5T600-600q0 17-11.5 28.5T560-560Zm0 200q81-69 120.5-127.5T720-596q0-75-48.5-119.5T560-760q-63 0-111.5 44.5T400-596q0 50 39.5 108.5T560-360Z"
                                />
                            </svg>
                            {/* <ListAltIcon fontSize="small" /> */}
                        </IconButton>
                    </Tooltip>

                    {/* Кнопка архивных задач (только для админов) */}
                    {isAdmin && (
                        <Tooltip title="Удаленные задачи">
                            <IconButton
                                size="small"
                                onClick={handleOpenDeletedTasksDialog}
                                sx={{
                                    color: darkMode ? '#f44336' : '#d32f2f',
                                    backgroundColor: deletedTasksDialogOpen ? (darkMode ? 'rgba(244,67,54,0.2)' : 'rgba(211,47,47,0.1)') : 'transparent',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(244,67,54,0.1)' : 'rgba(211,47,47,0.08)'
                                    }
                                }}
                            >
                                <ArchiveIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}
                    {/* Переключатель фантомных линий */}
                    {!fromStartPage && (
                        <Tooltip title="Отобразить план на карте">
                            <IconButton
                                size="small"
                                onClick={() => setShowFiders(!showFiders)}
                                sx={{
                                    color: darkMode ? '#f5f7fa' : '#333',
                                    backgroundColor: showFiders ? (darkMode ? 'rgba(157, 195, 132, 0.4)' : 'rgba(118, 146, 100, 0.4)') : 'transparent',
                                    '&:hover': {
                                        backgroundColor: darkMode ? 'rgba(157, 195, 132, 0.2)' : 'rgba(118, 146, 100, 0.2)'
                                    }
                                }}
                            >
                                {/* <PolylineIcon fontSize="small" /> */}
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill={darkMode ? 'rgba(157, 195, 132, 1)' : 'rgba(118, 146, 100, 1)'}>
                                    <path d="m270-120-10-88 114-314q15 14 32.5 23.5T444-484L334-182l-64 62Zm420 0-64-62-110-302q20-5 37.5-14.5T586-522l114 314-10 88ZM480-520q-50 0-85-35t-35-85q0-39 22.5-69.5T440-752v-88h80v88q35 12 57.5 42.5T600-640q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Z"
                                    />
                                </svg>
                            </IconButton>
                        </Tooltip>
                    )}


                    {/* Переключатель режимов */}
                    <ButtonGroup
                        size="small"
                        variant="outlined"
                        orientation="horizontal"
                        sx={{
                            '& .MuiButton-root': {
                                borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.4)',
                                color: darkMode ? '#f5f7fa' : '#555',
                                fontSize: { xs: '0.75rem', md: '0.875rem' },
                                px: { xs: 1, md: 1.5 }
                            }
                        }}
                    >
                        <Tooltip title="Режим канбан">
                            <Button
                                variant={viewMode === 'kanban' ? 'contained' : 'outlined'}
                                onClick={() => setViewMode('kanban')}
                                sx={{
                                    minWidth: { xs: '32px', md: '40px' },
                                    bgcolor: viewMode === 'kanban' ? '#1C85ED' : (darkMode ? 'transparent' : 'rgba(245, 245, 245, 0.8)'),
                                    color: viewMode === 'kanban' ? 'white' : (darkMode ? '#f5f7fa' : '#444'),
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.35)',
                                    '&:hover': {
                                        bgcolor: viewMode === 'kanban' ? '#1565c0' : (darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(28, 133, 237, 0.12)'),
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : '#1C85ED',
                                        color: viewMode === 'kanban' ? 'white' : (darkMode ? '#f5f7fa' : '#1C85ED')
                                    }
                                }}
                            >
                                <KanbanIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Режим таблица">
                            <Button
                                variant={viewMode === 'table' ? 'contained' : 'outlined'}
                                onClick={() => setViewMode('table')}
                                sx={{
                                    minWidth: { xs: '32px', md: '40px' },
                                    bgcolor: viewMode === 'table' ? '#1C85ED' : (darkMode ? 'transparent' : 'rgba(245, 245, 245, 0.8)'),
                                    color: viewMode === 'table' ? 'white' : (darkMode ? '#f5f7fa' : '#444'),
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.35)',
                                    '&:hover': {
                                        bgcolor: viewMode === 'table' ? '#1565c0' : (darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(28, 133, 237, 0.12)'),
                                        borderColor: darkMode ? 'rgba(255,255,255,0.4)' : '#1C85ED',
                                        color: viewMode === 'table' ? 'white' : (darkMode ? '#f5f7fa' : '#1C85ED')
                                    }
                                }}
                            >
                                <TableIcon sx={{ fontSize: { xs: '16px', md: '20px' } }} />
                            </Button>
                        </Tooltip>
                    </ButtonGroup>

                    {/* Переключатель темного режима */}
                    {/* <Tooltip title={darkMode ? "Светлая тема" : "Темная тема"}>
                        <IconButton
                            size="small"
                            onClick={() => dispatch(toggleDarkMode())}
                            sx={{
                                color: darkMode ? '#f5f7fa' : '#333',
                                p: { xs: 0.5, md: 1 },
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)'
                                }
                            }}
                        >
                            {darkMode ?
                                <LightModeIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} /> :
                                <DarkModeIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />
                            }
                        </IconButton>
                    </Tooltip> */}



                    {!fromStartPage && (
                        <IconButton
                            onClick={handleClose}
                            size="small"
                            sx={{
                                color: darkMode ? '#f5f7fa' : '#333',
                                p: { xs: 0.5, md: 1 },
                                '&:hover': {
                                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)'
                                }
                            }}
                        >
                            <CloseIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />
                        </IconButton>
                    )}
                </Box>
            </Box>

            {/* Панель инструментов */}
            <Box sx={{
                p: { xs: 0.5, md: 1 },
                borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
                bgcolor: darkMode ? '#252525' : '#f8fafc',
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap: { xs: 1, md: 2 },
                alignItems: { xs: 'stretch', md: 'center' },
                justifyContent: 'space-between'
            }}>
                {/* Левая группа - поиск и фильтры */}
                <Box sx={{
                    display: 'flex',
                    gap: { xs: 1, md: 2 },
                    flex: 1,
                    flexDirection: { xs: 'column', sm: 'row' },
                    flexWrap: 'wrap',
                    alignItems: { xs: 'stretch', sm: 'center' }
                }}>

                    {/* Поиск */}
                    <TextField
                        size="small"
                        placeholder="Поиск задач..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: <SearchIcon sx={{
                                    mr: 1,
                                    color: darkMode ? '#bbb' : 'text.secondary',
                                    fontSize: { xs: '18px', md: '20px' }
                                }} />
                            }
                        }}

                        sx={{
                            minWidth: { xs: 'auto', md: '250px' },
                            flex: { xs: 1, sm: 'none' },
                            '& .MuiOutlinedInput-root': {
                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#1976d2'
                                }
                            },
                            '& .MuiInputBase-input': {
                                color: darkMode ? '#f5f7fa' : '#333',
                                py: { xs: 0.5, md: 0.5 },
                                '&::placeholder': {
                                    color: darkMode ? '#bbb' : '#666',
                                    opacity: 1,
                                    fontSize: { xs: '0.875rem', md: '1rem' }
                                }
                            }
                        }}
                    />

                    {/* Кнопка продвинутых фильтров */}
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<FilterIcon />}
                        onClick={() => {
                            console.log('Кнопка фильтров нажата, текущее состояние:', showAdvancedFilters);
                            setShowAdvancedFilters(!showAdvancedFilters);
                        }}
                        sx={{
                            borderColor: darkMode ? '#64b5f6' : '#1976d2',
                            color: darkMode ? '#64b5f6' : '#1976d2',
                            px: 1,
                            py: 0.5,
                            textTransform: 'none',
                            fontSize: '0.75rem',
                            fontWeight: 600,
                            borderRadius: 1,
                            minWidth: 'auto',
                            flex: { xs: 1, sm: 'none' },
                            '&:hover': {
                                borderColor: darkMode ? '#42a5f5' : '#1565c0',
                                bgcolor: darkMode ? 'rgba(100, 181, 246, 0.1)' : 'rgba(25, 118, 210, 0.1)',
                                transform: 'translateY(-1px)',
                            },
                            transition: 'all 0.2s ease',
                            ...(getActiveAdvancedFiltersCount() > 0 && {
                                bgcolor: darkMode ? 'rgba(100, 181, 246, 0.2)' : 'rgba(25, 118, 210, 0.2)',
                                borderColor: darkMode ? '#42a5f5' : '#1565c0',
                            })
                        }}
                    >
                        Фильтры
                        {getActiveAdvancedFiltersCount() > 0 && (
                            <Chip
                                label={getActiveAdvancedFiltersCount()}
                                size="small"
                                sx={{
                                    ml: 0.5,
                                    height: 16,
                                    minWidth: 16,
                                    fontSize: '0.6rem',
                                    bgcolor: darkMode ? '#42a5f5' : '#1565c0',
                                    color: 'white',
                                    '& .MuiChip-label': {
                                        px: 0.5
                                    }
                                }}
                            />
                        )}
                    </Button>

                    {/* Фильтр по ответственному */}
                    {/* <Autocomplete
                        size="small"
                        options={[
                            { id: 'all', label: 'Все пользователи' },
                            ...usersWithTasks.map(user => ({
                                id: user.id.toString(),
                                label: user.display_name || user.username
                            }))
                        ]}
                        value={
                            responsibleFilter === 'all'
                                ? { id: 'all', label: 'Все пользователи' }
                                : usersWithTasks.find(user => user.id.toString() === responsibleFilter)
                                    ? {
                                        id: responsibleFilter,
                                        label: usersWithTasks.find(user => user.id.toString() === responsibleFilter)?.display_name ||
                                            usersWithTasks.find(user => user.id.toString() === responsibleFilter)?.username
                                    }
                                    : null
                        }
                        onChange={(event, newValue) => {
                            setResponsibleFilter(newValue ? newValue.id : 'all');
                        }}
                        getOptionLabel={(option) => option.label}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Ответственный"
                                slotProps={{
                                    input: {
                                        ...params.InputProps,
                                        startAdornment: (
                                            <>
                                                <PersonIcon sx={{
                                                    mr: 1,
                                                    color: darkMode ? '#bbb' : 'text.secondary',
                                                    fontSize: { xs: '18px', md: '20px' }
                                                }} />
                                                {params.InputProps.startAdornment}
                                            </>
                                        ),
                                    }
                                }}
                            />
                        )}
                        sx={{
                            minWidth: { xs: 'auto', md: '250px' },
                            flex: { xs: 1, sm: 'none' },
                            '& .MuiInputLabel-root': {
                                color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                '&.Mui-focused': {
                                    color: '#1976d2'
                                }
                            },
                            '& .MuiOutlinedInput-root': {
                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#1976d2'
                                },
                                '& .MuiAutocomplete-input': {
                                    padding: { xs: '0.75rem 0', md: '1rem 0' }
                                }
                            },
                            '& .MuiSvgIcon-root': {
                                color: darkMode ? '#bbb' : '#666'
                            },
                            '& .MuiIconButton-root': {
                                color: darkMode ? '#bbb' : '#666',
                                '&:hover': {
                                    bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                }
                            }
                        }}
                        slotProps={{
                            popper: {
                                sx: {
                                    zIndex: 13000,
                                    '& .MuiPaper-root': {
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                                        '& .MuiAutocomplete-option': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                            },
                                            '&.Mui-focused': {
                                                bgcolor: darkMode ? 'rgba(25, 118, 210, 0.12)' : 'rgba(25, 118, 210, 0.08)'
                                            }
                                        }
                                    }
                                }
                            }
                        }}

                    /> */}

                    {/* Сортировка */}
                    <FormControl
                        size="small"
                        sx={{
                            minWidth: { xs: 'auto', md: '200px' },
                            flex: { xs: 1, sm: 'none' },
                            '& .MuiInputLabel-root': {
                                color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                '&.Mui-focused': {
                                    color: '#1976d2'
                                }
                            }
                        }}
                    >
                        <InputLabel>Сортировка</InputLabel>
                        <Select
                            value={sortMode}
                            onChange={(e) => setSortMode(e.target.value)}
                            label="Сортировка"
                            startAdornment={
                                sortMode.endsWith('_asc') ?
                                    <ArrowUpIcon sx={{
                                        mr: 1,
                                        color: darkMode ? '#bbb' : 'text.secondary',
                                        fontSize: { xs: '18px', md: '20px' }
                                    }} /> :
                                    <ArrowDownIcon sx={{
                                        mr: 1,
                                        color: darkMode ? '#bbb' : 'text.secondary',
                                        fontSize: { xs: '18px', md: '20px' }
                                    }} />
                            }
                            sx={{
                                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                color: darkMode ? '#f5f7fa' : '#333',
                                fontSize: { xs: '0.875rem', md: '1rem' },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)'
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#1976d2'
                                },
                                '& .MuiSelect-icon': {
                                    color: darkMode ? '#bbb' : 'rgba(0,0,0,0.54)'
                                },
                                '& .MuiSelect-select': {
                                    py: { xs: 0.5, md: 0.5 }
                                }
                            }}
                            MenuProps={{
                                sx: {
                                    zIndex: 5002
                                },
                                PaperProps: {
                                    sx: {
                                        bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                        border: darkMode ? '1px solid rgba(255,255,255,0.12)' : '1px solid rgba(0,0,0,0.12)',
                                        '& .MuiMenuItem-root': {
                                            color: darkMode ? '#f5f7fa' : '#333',
                                            '&:hover': {
                                                bgcolor: darkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'
                                            },
                                            '&.Mui-selected': {
                                                bgcolor: darkMode ? 'rgba(25, 118, 210, 0.12)' : 'rgba(25, 118, 210, 0.08)',
                                                '&:hover': {
                                                    bgcolor: darkMode ? 'rgba(25, 118, 210, 0.16)' : 'rgba(25, 118, 210, 0.12)'
                                                }
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value="id_desc">По ID (по убыванию)</MenuItem>
                            <MenuItem value="id_asc">По ID (по возрастанию)</MenuItem>
                            <MenuItem value="created_desc">По дате создания (сначала новые)</MenuItem>
                            <MenuItem value="created_asc">По дате создания (сначала старые)</MenuItem>
                            <MenuItem value="deadline_desc">По дедлайну (сначала поздние)</MenuItem>
                            <MenuItem value="deadline_asc">По дедлайну (сначала ранние)</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {/* Правая группа - кнопки действий */}
                <Box sx={{
                    display: 'flex',
                    gap: { xs: 0.5, md: 1 },
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'stretch'
                }}>


                    {/* Кнопка создания задачи по контуру */}
                    {canCreateTasks && !fromStartPage && (
                        <Button
                            variant="outlined"
                            startIcon={<TimelineIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />}
                            onClick={handleCreateTaskByContour}
                            size={isMobile ? 'small' : 'medium'}
                            sx={{
                                borderColor: darkMode ? '#ba68c8' : '#9c27b0',
                                color: darkMode ? '#ba68c8' : '#9c27b0',
                                fontSize: { xs: '0.8rem', md: '0.875rem' },
                                py: { xs: 0.5, md: 0.5 },
                                '&:hover': {
                                    bgcolor: darkMode ? 'rgba(156, 39, 176, 0.12)' : 'rgba(156, 39, 176, 0.04)',
                                    borderColor: darkMode ? '#ab47bc' : '#7b1fa2',
                                    color: darkMode ? '#ce93d8' : '#7b1fa2'
                                }
                            }}
                        >
                            {/* Сокращаем текст на мобильных */}
                            <Box component="span" >
                                Задача по карте
                            </Box>

                        </Button>
                    )}

                    {/* Кнопка создания обычной задачи (только для табличного режима) */}
                    {viewMode === 'table' && canCreateTasks && (
                        <Button
                            variant="contained"
                            startIcon={<AddIcon sx={{ fontSize: { xs: '18px', md: '20px' } }} />}
                            onClick={openCreateTaskDialog}
                            size={isMobile ? 'small' : 'medium'}
                            sx={{
                                bgcolor: darkMode ? '#8bc34a' : '#7cb342',
                                color: 'white',
                                fontSize: { xs: '0.8rem', md: '0.875rem' },
                                py: { xs: 0.5, md: 0.5 },
                                '&:hover': {
                                    bgcolor: darkMode ? '#7cb342' : '#689f38',
                                    transform: { xs: 'none', md: 'translateY(-1px)' },
                                    boxShadow: darkMode
                                        ? '0 4px 8px rgba(139, 195, 74, 0.4)'
                                        : '0 4px 8px rgba(124, 179, 66, 0.3)'
                                }
                            }}
                        >
                            {/* Сокращаем текст на мобильных */}
                            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                Создать задачу
                            </Box>
                            <Box component="span" sx={{ display: { xs: 'inline', sm: 'none' } }}>
                                Создать
                            </Box>
                        </Button>
                    )}
                </Box>
            </Box>

            {/* Продвинутые фильтры */}
            {showAdvancedFilters && (
                <Box sx={{
                    bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                    borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
                    p: 2
                }}>
                    <AdvancedFiltersComponent
                        darkMode={darkMode}
                        advancedFilters={advancedFilters}
                        onClearFilters={handleClearAdvancedFilters}
                        addFilter={addFilter}
                        removeFilter={removeFilter}
                        updateFilter={updateFilter}
                        getAvailableFiltersForSelect={getAvailableFiltersForSelect}
                    />
                </Box>
            )}

            {/* <Box id="kanban-dialog-description" sx={{ bgcolor: 'inherit', p: 0, display: 'contents', width: '100%', height: '100%', flexDirection: 'column' }}> */}


            {/* <Box sx={{
                flex: 1,
                display: 'flex',
                width: '100%',
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                    height: '8px'
                },
                '&::-webkit-scrollbar-track': {
                    background: darkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                    borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb': {
                    background: darkMode ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.2)',
                    borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    background: darkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.3)'
                },
            }}>
                {viewMode === 'kanban' ? (
                    <KanbanView
                        sensors={sensors}
                        customCollisionDetection={customCollisionDetection}
                        handleDragStart={handleDragStart}
                        handleDragEnd={handleDragEnd}
                        handleDragCancel={handleDragCancel}
                        darkMode={darkMode}
                        statusDefs={statusDefs}
                        isOverdueCollapsed={isOverdueCollapsed}
                        setIsOverdueCollapsed={setIsOverdueCollapsed}
                        canCreateTasks={canCreateTasks}
                        openCreateTaskDialog={openCreateTaskDialog}
                        draggedTask={draggedTask}
                        allowedTransitions={allowedTransitions}
                        tasks={tasks}
                        handleEditTask={handleEditTask}
                        handleDeleteTask={handleDeleteTask}
                        handleViewSpecs={handleViewSpecs}
                        handleFocusOnTaskArea={handleFocusOnTaskArea}
                        canEditTask={canEditTask}
                        canDragTask={canDragTask}
                        canDeleteTask={canDeleteTask}
                    />
                ) : (
                    <TableView
                        darkMode={darkMode}
                        getAllTasks={getAllTasks}
                        canDragTask={canDragTask}
                        canEditTask={canEditTask}
                        canDeleteTask={canDeleteTask}
                        handleStatusChange={handleStatusChange}
                        handleEditTask={handleEditTask}
                        handleDeleteTask={handleDeleteTask}
                        handleViewSpecs={handleViewSpecs}
                        handleFocusOnTaskArea={handleFocusOnTaskArea}
                        formatDate={formatDate}
                    />
                )}
            </Box> */}
            {/* </Box> */}
        </React.Fragment>
    }

    return (
        <>
            {!isModal ?
                (<Box
                    sx={{

                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%',
                        bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                        color: darkMode ? '#f5f7fa' : '#333',
                        overflow: 'hidden'
                    }}
                >
                    {ContentHeader()}
                    {/* Продвинутые фильтры */}
                    {/* {showAdvancedFilters && (
                        <Box sx={{
                            bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                            borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
                            p: 2
                        }}>
                            <AdvancedFiltersComponent
                                darkMode={darkMode}
                                advancedFilters={advancedFilters}
                                onClearFilters={handleClearAdvancedFilters}
                                addFilter={addFilter}
                                removeFilter={removeFilter}
                                updateFilter={updateFilter}
                                getAvailableFiltersForSelect={getAvailableFiltersForSelect}
                            />
                        </Box>
                    )} */}
                    <Box sx={{
                        flex: 1,
                        display: 'flex',
                        width: '100%',
                        overflow: 'hidden'
                    }}>
                        {viewMode === 'kanban' ? (
                            <KanbanView2
                                darkMode={darkMode}
                                isOverdueCollapsed={isOverdueCollapsed}
                                setIsOverdueCollapsed={setIsOverdueCollapsed}
                                canCreateTasks={canCreateTasks}
                                openCreateTaskDialog={openCreateTaskDialog}
                                tasks={tasks}
                                users={usersMap}
                                handleEditTask={handleEditTask}
                                handleDeleteTask={handleDeleteTask}
                                handleViewSpecs={handleViewSpecs}
                                handleViewFiles={handleViewFiles}
                                handleFocusOnTaskArea={handleFocusOnTaskArea}
                                handleOpenHistoryDialog={handleOpenHistoryDialog}
                                canEditTask={canEditTask}
                                canDragTask={canDragTask}
                                canDeleteTask={canDeleteTask}
                            />
                        ) : (
                            <TableView2
                                darkMode={darkMode}
                                getAllTasks={getAllTasks}
                                users={usersMap}
                                canDragTask={canDragTask}
                                canEditTask={canEditTask}
                                canDeleteTask={canDeleteTask}
                                handleStatusChange={handleStatusChange}
                                handleEditTask={handleEditTask}
                                handleDeleteTask={handleDeleteTask}
                                handleViewSpecs={handleViewSpecs}
                                handleViewFiles={handleViewFiles}
                                handleFocusOnTaskArea={handleFocusOnTaskArea}
                                handleOpenHistoryDialog={handleOpenHistoryDialog}
                                formatDate={formatDate}
                            />
                        )}
                    </Box>
                </Box >)
                :
                (<Dialog
                    open={isOpen && !isMinimized}
                    onClose={handleClose}
                    maxWidth="xxl"
                    fullWidth
                    fullScreen={isMobile}
                    // sx={{ zIndex: 1500 }}
                    className="kanban-modal"
                    aria-labelledby="kanban-dialog-title"
                    aria-describedby="kanban-dialog-description"
                    slotProps={{
                        paper: {
                            sx: {
                                overflow: 'hidden',
                                minHeight: '85vh',
                                bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                                color: darkMode ? '#f5f7fa' : '#333',
                                position: 'relative',
                                zIndex: 5001,
                            },
                            'aria-modal': true,
                            role: 'dialog'
                        }
                    }}
                >
                    {ContentHeader()}
                    {/* Продвинутые фильтры */}
                    {/* {showAdvancedFilters && (
                        <Box sx={{
                            bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                            borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.12)' : 'rgba(0,0,0,0.12)'}`,
                            p: 2
                        }}>
                            <AdvancedFiltersComponent
                                darkMode={darkMode}
                                advancedFilters={advancedFilters}
                                onClearFilters={handleClearAdvancedFilters}
                                addFilter={addFilter}
                                removeFilter={removeFilter}
                                updateFilter={updateFilter}
                                getAvailableFiltersForSelect={getAvailableFiltersForSelect}
                            />
                        </Box>
                    )} */}
                    <Box sx={{
                        flex: 1,
                        display: 'flex',
                        width: '100%',
                        overflow: 'hidden'
                    }}>
                        {viewMode === 'kanban' ? (
                            <KanbanView2
                                darkMode={darkMode}
                                isOverdueCollapsed={isOverdueCollapsed}
                                setIsOverdueCollapsed={setIsOverdueCollapsed}
                                canCreateTasks={canCreateTasks}
                                openCreateTaskDialog={openCreateTaskDialog}
                                tasks={tasks}
                                users={usersMap || new Map()}
                                handleEditTask={handleEditTask}
                                handleDeleteTask={handleDeleteTask}
                                handleViewSpecs={handleViewSpecs}
                                handleViewFiles={handleViewFiles}
                                handleFocusOnTaskArea={handleFocusOnTaskArea}
                                handleOpenHistoryDialog={handleOpenHistoryDialog}
                                canEditTask={canEditTask}
                                canDragTask={canDragTask}
                                canDeleteTask={canDeleteTask}
                            />
                        ) : (
                            <TableView2
                                darkMode={darkMode}
                                getAllTasks={getAllTasks}
                                users={usersMap}
                                canDragTask={canDragTask}
                                canEditTask={canEditTask}
                                canDeleteTask={canDeleteTask}
                                handleStatusChange={handleStatusChange}
                                handleEditTask={handleEditTask}
                                handleDeleteTask={handleDeleteTask}
                                handleViewSpecs={handleViewSpecs}
                                handleViewFiles={handleViewFiles}
                                handleFocusOnTaskArea={handleFocusOnTaskArea}
                                handleOpenHistoryDialog={handleOpenHistoryDialog}
                                formatDate={formatDate}
                            />
                        )}
                    </Box>
                </Dialog >)
            }


            {/* Диалог создания задачи */}
            {
                createDialogOpen && <TaskCreateAndSaveDialog
                    formData={formData}
                    task={null}
                    specs={specs_new}
                    saveCallback={(data) => {
                        handleCreateTask(data)
                        setCreateDialogOpen(false);
                        resetForm();
                    }}
                    cancelCallabck={() => {
                        setCreateDialogOpen(false);
                        resetForm();
                    }}
                    users={users}
                    loadingUsers={false}
                    darkMode={darkMode}
                    isMobile={isMobile}
                    currentUser={user}
                    isEditing={false}
                    getLayerName={getLayerName}
                    getObjectName={getObjectName}
                    objectsIds={taskData?.objects}
                    objects={taskObjects}
                />
            }


            {/* Диалог редактирования задачи */}
            {
                editDialogOpen && <TaskCreateAndSaveDialog
                    formData={formData}
                    task={currentTask}
                    specs={specs_new}
                    saveCallback={(data) => {
                        handleSaveTask(data)
                        setCreateDialogOpen(false);
                        resetForm();
                    }}
                    cancelCallabck={() => {
                        setEditDialogOpen(false);
                        resetForm();
                    }}
                    users={users}
                    loadingUsers={false}
                    darkMode={darkMode}
                    isMobile={isMobile}
                    currentUser={user}
                    isEditing={true}
                    getLayerName={getLayerName}
                    getObjectName={getObjectName}
                    objectsIds={taskData?.objects}
                    objects={taskObjects}
                />
            }

            {/* Мини-окно для рисования контура */}
            {
                isDrawing && (
                    createPortal(
                        <ThemeProvider theme={theme}>
                            <Box
                                sx={{
                                    position: 'fixed',
                                    top: isMobile ? 0 : 70,
                                    right: isMobile ? 0 : 20,
                                    left: isMobile ? 0 : 'auto',
                                    width: isMobile ? '100vw' : '480px',
                                    zIndex: 2000,
                                    bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                                    borderRadius: isMobile ? 0 : 3,
                                    boxShadow: isMobile
                                        ? 'none'
                                        : (darkMode
                                            ? '0 8px 32px rgba(0, 0, 0, 0.4)'
                                            : '0 8px 32px rgba(0, 0, 0, 0.12)'),
                                    overflow: 'hidden',
                                    backdropFilter: 'blur(10px)',
                                    animation: 'slideIn 0.3s ease-out',
                                    '@keyframes slideIn': {
                                        from: {
                                            opacity: 0,
                                            transform: 'translateY(-20px)',
                                        },
                                        to: {
                                            opacity: 1,
                                            transform: 'translateY(0)',
                                        },
                                    },
                                }}
                            >
                                {/* Заголовок */}
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    py: 1,
                                    px: 2,
                                    bgcolor: darkMode ? '#2b2b2b' : '#fff',
                                    borderBottom: darkMode
                                        ? '1px solid rgba(255, 255, 255, 0.12)'
                                        : '1px solid rgba(0, 0, 0, 0.12)',
                                    color: darkMode ? '#f5f7fa' : '#333'
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Box sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            width: 30,
                                            height: 30,
                                            borderRadius: '50%',
                                            bgcolor: 'rgba(156, 39, 176, 0.1)',
                                            border: '2px dashed #9c27b0',
                                            animation: 'pulse 2s ease-in-out infinite',
                                            '@keyframes pulse': {
                                                '0%': {
                                                    transform: 'scale(1)',
                                                    opacity: 0.7
                                                },
                                                '50%': {
                                                    transform: 'scale(1.05)',
                                                    opacity: 1
                                                },
                                                '100%': {
                                                    transform: 'scale(1)',
                                                    opacity: 0.7
                                                }
                                            }
                                        }}>
                                            <TimelineIcon sx={{
                                                fontSize: '24px',
                                                color: '#9c27b0'
                                            }} />
                                        </Box>
                                        {/* <DrawIcon sx={{
                                            fontSize: '24px',
                                            color: '#9c27b0'
                                        }} /> */}
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '1.1rem'
                                            }}
                                        >
                                            Нарисуйте контур на карте
                                        </Typography>
                                    </Box>

                                    <IconButton
                                        onClick={handleCancelContour}
                                        size="small"
                                        sx={{
                                            color: darkMode ? '#f5f7fa' : '#666',
                                            '&:hover': {
                                                bgcolor: 'rgba(244, 67, 54, 0.1)',
                                                color: '#f44336'
                                            }
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </Box>

                                {/* Контент */}
                                {!polygon ? null : (() => {
                                    const [data, excludedObjects] = findObjectsInBounds();
                                    const totalObjects = Object.values(data.objects || {}).reduce((sum, arr) => sum + (arr?.length || 0), 0);
                                    const totalExcludedObjects = Object.values(excludedObjects || {}).reduce((sum, arr) => sum + (arr?.length || 0), 0);

                                    return (
                                        <Box sx={{
                                            py: 1,
                                            px: 2,
                                            bgcolor: darkMode ? '#1e1e1e' : '#f5f7fa',
                                            maxHeight: 'calc(100vh - 300px)',
                                            overflowY: 'auto'
                                        }}>
                                            {/* Заголовок с иконкой */}
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mb: 2,
                                                gap: 1
                                            }}>
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: 32,
                                                    height: 32,
                                                    borderRadius: '50%',
                                                    bgcolor: 'rgba(76, 175, 80, 0.1)',
                                                    border: '2px solid #4caf50'
                                                }}>
                                                    <CheckCircleIcon sx={{
                                                        fontSize: '20px',
                                                        color: '#4caf50'
                                                    }} />
                                                </Box>
                                                <Typography variant="subtitle2" sx={{
                                                    fontWeight: 600,
                                                    color: darkMode ? '#4caf50' : '#2e7d32'
                                                }}>
                                                    Найдено объектов: {totalObjects}
                                                </Typography>
                                            </Box>
                                            {/* Исключено с иконкой */}
                                            {totalExcludedObjects > 0 &&
                                                <Box sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    mb: 2,
                                                    gap: 1
                                                }}>
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: 32,
                                                        height: 32,
                                                        borderRadius: '50%',
                                                        bgcolor: 'rgba(175, 76, 76, 0.1)',
                                                        border: '2px solid rgb(175, 76, 76)'
                                                    }}>
                                                        <CancelIcon sx={{
                                                            fontSize: '20px',
                                                            color: 'rgb(175, 87, 76)'
                                                        }} />
                                                    </Box>
                                                    <Typography variant="subtitle2" sx={{
                                                        fontWeight: 600,
                                                        color: darkMode ? 'rgb(175, 76, 76)' : 'rgb(175, 76, 76)'
                                                    }}>
                                                        Пропущено объектов задействаванных в других планах: {totalExcludedObjects}
                                                    </Typography>
                                                </Box>
                                            }


                                            {/* Кнопка подтверждения */}
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button
                                                    variant="contained"
                                                    onClick={handleConfirmContour}
                                                    startIcon={<SaveIcon />}
                                                    sx={{
                                                        bgcolor: '#4caf50',
                                                        color: 'white',
                                                        fontWeight: 600,
                                                        px: 3,
                                                        py: 0.5,
                                                        borderRadius: 2,
                                                        textTransform: 'none',
                                                        fontSize: '0.875rem',
                                                        '&:hover': {
                                                            bgcolor: '#45a049',
                                                            transform: 'translateY(-1px)',
                                                            boxShadow: '0 4px 12px rgba(76, 175, 80, 0.4)'
                                                        }
                                                    }}
                                                >
                                                    Создать задачу
                                                </Button>
                                            </Box>
                                        </Box>
                                    );
                                })()}
                            </Box>
                        </ThemeProvider>,
                        document.body
                    )
                )
            }


            {/* Диалог просмотра материалов */}
            {specsDialogOpen && (
                <SpecsViewDialog
                    currentTaskSpecs={currentTaskSpecs}
                    currentTaskFullSpecs={getObjectsFullSpecs(currentTaskSpecs.data)}
                    specs={specs_new}
                    getLayerName={getLayerName}
                    getObjectName={getObjectName}
                    handleDialogClose={handleSpecsDialogClose}
                    darkMode={darkMode}
                    isMobile={isMobile}
                />
            )}


            {/* Диалог подтверждения удаления */}
            {deleteConfirmOpen && canDeleteTask() && (
                <TaskDeleteConfirmDialog
                    taskToDelete={currentTask}
                    handleCancel={cancelDeleteTask}
                    handleConfirm={confirmDeleteTask}
                    darkMode={darkMode}
                    isMobile={isMobile}
                />
            )}


            {/* Диалог архивных задач */}
            {deletedTasksDialogOpen && (
                <DeletedTasksDialog
                    users={usersMap}
                    handleDialogClose={handleCloseDeletedTasksDialog}
                    darkMode={darkMode}
                    isMobile={isMobile}
                    statusDefs={statusDefs}
                    formatDate={formatDate}
                />
            )}

            {/* Диалог истории изменений */}
            <AuditHistoryDialog
                open={historyDialogOpen}
                onClose={handleCloseHistoryDialog}
                tableName="tasks"
                tableTitle="Задачи"
                recordId={currentTask?.id}
                recordTitle={currentTask?.title}
                darkMode={darkMode}
                translates={{
                    'id': 'ID',
                    'name': 'Название',
                    'desc': 'Описание',
                    'status': 'Статус',
                    'responsible': 'Ответственный',
                    'creator': 'Создатель',
                    'project_id': 'Проект',
                    'coexecutors': 'Соисполнители',
                    'created_at': 'Дата создания',
                    'deadline': 'Срок выполнения'
                }}
                formatting={{
                    'deadline': formatDate,
                    'status': (value) => {
                        return statusDefs.find(s => s.id === value)?.title
                    },
                    'responsible': (value) => {
                        return usersMap.get(value)
                    },
                    creator: (value) => {
                        return usersMap.get(value)
                    },
                    coexecutors: (value) => {
                        return value.map(v => usersMap.get(v)).join(', ')
                    }
                }}
                ignore={['editor', 'edited_at']}
            />

            {/* Диалог просмотра файлов */}
            <TaskFilesDialog
                open={filesDialogOpen}
                user={user}
                users={usersMap}
                updateFiles={handleUpdateFiles}
                onClose={handleFilesDialogClose}
                task={currentTaskFiles}
                darkMode={darkMode}
            />

        </>
    );
};

export default TasksView; 